<template>
  <div id="bankinput">
    <loading-overlay v-if="isLoading"></loading-overlay>
    <div class="title">
      <h2>破产案件录入</h2>
    </div>
    <div class="main">
      <el-card class="main_card">
        <div class="case">
          <div class="contain">
            <el-form
              class="form"
              ref="formref"
              :model="form"
              :rules="formrules"
              label-width="160px"
            >
              <div class="top">
                <div class="icon"></div>
                <div>案件信息</div>
              </div>
              <el-row>
                <el-form-item label="项目名称" prop="title">
                  <el-input
                    v-model="form.title"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="项目概要" prop="cause">
                  <el-input
                    v-model="form.cause"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="案件编号" prop="code">
                    <el-input
                      v-model="form.code"
                      placeholder="自动编号"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="受理状态" prop="casestatus">
                    <el-select
                      v-model="form.casestatus"
                      placeholder="请选择"
                      class="select"
                    >
                      <el-option
                        v-for="item in CaseStatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="项目合伙人" prop="extInfo.partner">
                    <el-input
                      v-model="form.extInfo.partner"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="底稿资料" prop="extInfo.draft">
                    <el-select
                      v-model="form.extInfo.draft"
                      placeholder="请选择"
                      class="select"
                    >
                      <el-option
                        v-for="item in Draft"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="divider"></div>
              <el-row>
                <el-col :span="6" class="date_box">
                  <el-form-item label="立项日期" prop="postTime">
                    <div
                      class="date_box"
                      @mouseover="onMouseOver()"
                      @mouseleave="onMouseleave()"
                    >
                      <el-date-picker
                        value-format="yyyy-MM-dd"
                        style="width: 100%"
                        v-model="form.postTime"
                        type="date"
                        placeholder="请选择日期"
                      >
                      </el-date-picker>
                      <i class="el-icon-date" ref="iconDate"></i>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="项目来源" prop="source">
                    <el-input
                      v-model="form.source"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="管辖法院" prop="acceptUnit">
                    <el-input
                      v-model="form.acceptUnit"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="受理机构案号" prop="acceptCode">
                    <el-input
                      v-model="form.acceptCode"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="6">
                  <el-form-item label="破产案件类型" prop="extInfo.projecttype">
                    <el-select
                      style="width: 100%"
                      v-model="form.extInfo.projecttype"
                      placeholder="请选择"
                      class="select"
                    >
                      <el-option
                        v-for="item in ProjectType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="代理律师" prop="leadLawyer">
                    <el-select
                      style="width: 100%"
                      v-model="form.leadLawyer"
                      placeholder="请选择"
                      class="select"
                      @change="selectChange('1')"
                      multiple
                      :multiple-limit="1"
                      filterable
                    >
                      <el-option
                        v-for="item in computeDifferenceSet(form.leadLawyer)"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="代理律师" prop="coCounsel">
                    <el-select
                      style="width: 100%"
                      v-model="form.coCounsel"
                      placeholder="请选择"
                      class="select"
                      multiple
                      @change="selectChange()"
                      filterable
                    >
                      <el-option
                        v-for="item in computeDifferenceSet(form.coCounsel)"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="案件级别" prop="extInfo.caselevel">
                    <el-select
                      style="width: 100%"
                      v-model="form.extInfo.caselevel"
                      placeholder="请选择"
                      class="select"
                    >
                      <el-option
                        v-for="item in Level"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
               
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目负责人" prop="extInfo.porjectleader">
                    <el-input
                      v-model="form.extInfo.porjectleader"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="委托人摇号" prop="extInfo.lottery">
                    <el-input
                      v-model="form.extInfo.lottery"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="管理人账号" prop="extInfo.administrator">
                    <el-select
                      style="width: 100%"
                      v-model="form.extInfo.administrator"
                      placeholder="请选择"
                      class="select"
                    >
                      <el-option
                        v-for="item in Administrator"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!form.extInfo.administrator">
                <el-col :span="12">
                  <el-form-item label="开户账号" prop="extInfo.account">
                    <el-input
                      v-model="form.extInfo.account"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="开户银行" prop="extInfo.bank">
                    <el-input
                      v-model="form.extInfo.bank"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="部门审批人" prop="departmentLeaders">
                    <el-select
                      style="width: 100%"
                      v-model="form.departmentLeaders"
                      placeholder="请先选择代理律师"
                      class="select"
                      filterable
                    >
                      <el-option
                        v-for="item in depLeaders"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="二次审批人" prop="approve">
                    <el-select
                      style="width: 100%"
                      v-model="form.approve"
                      placeholder="请先选择代理律师"
                      class="select"
                      filterable
                    >
                      <el-option
                        v-for="item in approve"
                        :key="item.id"
                        :label="item.nikename"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="divider"></div>

              <el-row>
                <!-- <el-form-item label="债务人名称" prop="extInfo.debtorName">
                  <el-input
                    v-model="form.extInfo.debtorName"
                    placeholder="请输入"
                    @input="filterComma(form.extInfo)"
                  ></el-input>
                </el-form-item> -->
                <el-col :span="12">
                  <el-form-item label="债务人名称" prop="extInfo.debtorName">
                    <el-autocomplete
                          class="input_autocomplete"
                          @input="filterComma(form.extInfo)"
                          v-model="form.extInfo.debtorName"
                          :fetch-suggestions="querySearchName
                          "
                          placeholder="请输入"
                          :trigger-on-focus="false"
                          @select="handleSelectName
                          "
                        ></el-autocomplete>
                  <!-- <el-input
                    v-model="form.extInfo.debtorName"
                    placeholder="请输入"
                    @input="filterComma(form.extInfo)"
                  ></el-input> -->
                </el-form-item>
              </el-col>
                <el-col :span="12">
                <el-form-item label="身份证号/社会信用代码/护照号" prop="extInfo.idnumber" label-width="210px">
                  <el-input
                    v-model="form.extInfo.idnumber"
                    placeholder="请输入"
                    @input="filterComma(form.extInfo)"
                  ></el-input>
                </el-form-item>
                </el-col>
              </el-row>

              <div class="divider"></div>
              <div class="top">
                <div class="icon"></div>
                <div>收费信息</div>
              </div>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="收费方式" prop="chargingMethod">
                    <el-select
                      style="width: 100%"
                      v-model="form.chargingMethod"
                      placeholder="请选择"
                      class="select"
                    >
                      <el-option
                        v-for="item in chargestatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="案件标的物" prop="subjectMatter ">
                    <el-input
                      v-model="form.subjectMatter"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6" class="money" v-if="bankshow">
                  <el-form-item label="标的金额" prop="amountOfSubject">
                    <el-input
                      v-model="form.amountOfSubject"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="简介" prop="introduction">
                    <el-input
                      v-model="form.introduction"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="备注" prop="remark">
                    <el-input
                      v-model="form.remark"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="6" class="money" v-if="bankshow">
                  <!-- 定额收费金额 -->
                  <el-form-item
                    label="收费金额"
                    prop="fixed"
                    v-if="form.chargingMethod == '固定收费'"
                  >
                    <el-input
                      v-model="form.fixed"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                  <!-- 风险收费金额 -->
                  <el-form-item
                    label="收费金额"
                    prop="riskFixed"
                    v-if="form.chargingMethod == '风险收费'"
                  >
                    <el-input
                      v-model="form.riskFixed"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="6"
                  v-if="form.chargingMethod == '风险收费'"
                  class="money"
                >
                  <el-form-item
                    label="风险收费比例"
                    prop="riskRatio"
                    :rules="{
                      required: true,
                      validator: NewPrice,
                      trigger: 'change'
                    }"
                  >
                    <el-input
                      v-model="form.riskRatio"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                    <div style="margin-left: 4px">%</div>
                  </el-form-item>
                </el-col>
                <el-col :span="6" class="money">
                  <el-form-item label="债务人资产情况" prop="extInfo.asset">
                    <el-input
                      placeholder="不小于0"
                      v-model="form.extInfo.asset"
                    ></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" class="money">
                  <el-form-item label="抵押债权金额" prop="extInfo.debenture">
                    <el-input
                      placeholder="不小于0"
                      v-model="form.extInfo.debenture"
                    ></el-input>
                    <div style="margin-left: 4px">元</div>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row>
                <el-col :span="14">
                  <el-form-item label="合同用章" prop="sealType">
                    <el-select
                      style="width: 100%"
                      v-model="form.sealType"
                      placeholder="请选择"
                      class="select"
                    >
                      <el-option
                        v-for="item in seal"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <el-row v-if="bankshow">
                <el-col :span="8">
                  <el-form-item label="投标方案" prop="BiddingSchemes">
                    <el-upload
                      class="upload_file"
                      :show-file-list="false"
                      v-model="form.BiddingSchemes"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=招标"
                      :before-upload="(file) => beforeUpload(file, 1)"
                      :on-change="(file) => onChange(file, 1)"
                      :on-progress="(event, file) => onProgress(event, file, 1)"
                      multiple
                      :file-list="FileList1"
                      :on-success="
                        (response, file, fileList) =>
                          uploadSuccess(response, file, fileList, 1)
                      "
                      :on-remove="(file) => handleRemove(file, 1)"
                    >
                      <el-button size="small" class="fjchoose"
                        >请选择附件</el-button
                      >
                      <span slot="tip" class="el-upload__tip"
                        >单个上传50mb</span
                      >
                    </el-upload>
                    <!-- 附件回显 -->
                    <div
                      v-for="(item, index) in FileList1"
                      :key="item.uid"
                      class="file_show"
                      style="margin-top: 10px"
                    >
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img
                            src="../../assets/file/word.svg"
                            v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                          />
                          <img
                            src="../../assets/file/xls.svg"
                            v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                          />
                          <img
                            src="../../assets/file/png.svg"
                            v-if="
                              item.ftype == 'jpg' ||
                              item.ftype == 'jpeg' ||
                              item.ftype == 'png'
                            "
                          />
                          <img
                            src="../../assets/file/PDF.svg"
                            v-if="item.ftype == 'pdf'"
                          />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look">预览</span>
                            <!-- <span class="down" @click="down(item)">下载</span> -->
                            <span @click="del(index, 1)" class="del">删除</span>
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress
                            :percentage="item.curPercentage"
                            :show-text="false"
                          ></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="bankshow">
                <el-col :span="8">
                  <el-form-item
                    label="法院的受理裁定书"
                    prop="acceptanceRuling"
                  >
                    <el-upload
                      class="upload_file"
                      :show-file-list="false"
                      v-model="form.acceptanceRuling"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=法院的受理裁定书"
                      :before-upload="(file) => beforeUpload(file, 2)"
                      :on-change="(file) => onChange(file, 2)"
                      :on-progress="(event, file) => onProgress(event, file, 2)"
                      multiple
                      :file-list="FileList2"
                      :on-success="
                        (response, file, fileList) =>
                          uploadSuccess(response, file, fileList, 2)
                      "
                      :on-remove="(file) => handleRemove(file, 2)"
                    >
                      <el-button size="small" class="fjchoose"
                        >请选择附件</el-button
                      >
                      <span slot="tip" class="el-upload__tip"
                        >单个上传50mb</span
                      >
                    </el-upload>
                    <!-- 附件回显 -->
                    <div
                      v-for="(item, index) in FileList2"
                      :key="item.uid"
                      class="file_show"
                      style="margin-top: 10px"
                    >
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img
                            src="../../assets/file/word.svg"
                            v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                          />
                          <img
                            src="../../assets/file/xls.svg"
                            v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                          />
                          <img
                            src="../../assets/file/png.svg"
                            v-if="
                              item.ftype == 'jpg' ||
                              item.ftype == 'jpeg' ||
                              item.ftype == 'png'
                            "
                          />
                          <img
                            src="../../assets/file/PDF.svg"
                            v-if="item.ftype == 'pdf'"
                          />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look">预览</span>
                            <!-- <span class="down" @click="down(item)">下载</span> -->
                            <span @click="del(index, 2)" class="del">删除</span>
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress
                            :percentage="item.curPercentage"
                            :show-text="false"
                          ></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="bankshow">
                <el-col :span="8">
                  <el-form-item
                    label="管理人决定书"
                    prop="administratorDecision"
                  >
                    <el-upload
                      class="upload_file"
                      :show-file-list="false"
                      v-model="form.administratorDecision"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=管理人决定书"
                      :before-upload="(file) => beforeUpload(file, 3)"
                      :on-change="(file) => onChange(file, 3)"
                      :on-progress="(event, file) => onProgress(event, file, 3)"
                      multiple
                      :file-list="FileList3"
                      :on-success="
                        (response, file, fileList) =>
                          uploadSuccess(response, file, fileList, 3)
                      "
                      :on-remove="(file) => handleRemove(file, 3)"
                    >
                      <el-button size="small" class="fjchoose"
                        >请选择附件</el-button
                      >
                      <span slot="tip" class="el-upload__tip"
                        >单个上传50mb</span
                      >
                    </el-upload>
                    <!-- 附件回显 -->
                    <div
                      v-for="(item, index) in FileList3"
                      :key="item.uid"
                      class="file_show"
                      style="margin-top: 10px"
                    >
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img
                            src="../../assets/file/word.svg"
                            v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                          />
                          <img
                            src="../../assets/file/xls.svg"
                            v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                          />
                          <img
                            src="../../assets/file/png.svg"
                            v-if="
                              item.ftype == 'jpg' ||
                              item.ftype == 'jpeg' ||
                              item.ftype == 'png'
                            "
                          />
                          <img
                            src="../../assets/file/PDF.svg"
                            v-if="item.ftype == 'pdf'"
                          />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look">预览</span>
                            <!-- <span class="down" @click="down(item)">下载</span> -->
                            <span @click="del(index, 3)" class="del">删除</span>
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress
                            :percentage="item.curPercentage"
                            :show-text="false"
                          ></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="附件" prop="annex">
                    <el-upload
                      class="upload_file"
                      :show-file-list="false"
                      v-model="form.annex"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=附件"
                      :before-upload="(file) => beforeUpload(file, 4)"
                      :on-change="(file) => onChange(file, 4)"
                      :on-progress="(event, file) => onProgress(event, file, 4)"
                      multiple
                      :file-list="FileList4"
                      :on-success="
                        (response, file, fileList) =>
                          uploadSuccess(response, file, fileList, 4)
                      "
                      :on-remove="(file) => handleRemove(file, 4)"
                    >
                      <el-button size="small" class="fjchoose"
                        >请选择附件</el-button
                      >
                      <span slot="tip" class="el-upload__tip"
                        >单个上传50mb</span
                      >
                    </el-upload>
                    <!-- 附件回显 -->
                    <div
                      v-for="(item, index) in FileList4"
                      :key="item.uid"
                      class="file_show"
                      style="margin-top: 10px"
                    >
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img
                            src="../../assets/file/word.svg"
                            v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                          />
                          <img
                            src="../../assets/file/xls.svg"
                            v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                          />
                          <img
                            src="../../assets/file/png.svg"
                            v-if="
                              item.ftype == 'jpg' ||
                              item.ftype == 'jpeg' ||
                              item.ftype == 'png'
                            "
                          />
                          <img
                            src="../../assets/file/PDF.svg"
                            v-if="item.ftype == 'pdf'"
                          />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look">预览</span>
                            <!-- <span class="down" @click="down(item)">下载</span> -->
                            <span @click="del(index, 4)" class="del">删除</span>
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress
                            :percentage="item.curPercentage"
                            :show-text="false"
                          ></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="form.chargingMethod == '免费'">
                  <el-form-item label="免费凭证" prop="FreeFile">
                    <el-upload
                      class="upload_file"
                      :show-file-list="false"
                      v-model="form.FreeFile"
                      action="/api/Filer/PcUpload?flag=00000000-0000-0000-0000-000000000000&filetype=免费"
                      :before-upload="(file) => beforeUpload(file, 5)"
                      :on-change="(file) => onChange(file, 5)"
                      :on-progress="(event, file) => onProgress(event, file, 5)"
                      multiple
                      :file-list="FileList5"
                      :on-success="
                        (response, file, fileList) =>
                          uploadSuccess(response, file, fileList, 5)
                      "
                      :on-remove="(file) => handleRemove(file, 5)"
                    >
                      <el-button size="small" class="fjchoose"
                        >请选择附件</el-button
                      >
                      <!-- <span slot="tip" class="el-upload__tip">(附件不用上传)（0个）单个上传50mb</span> -->
                    </el-upload>
                    <!-- 附件回显 -->
                    <div
                      v-for="(item, index) in FileList5"
                      :key="item.uid"
                      class="file_show"
                      style="margin-top: 10px"
                    >
                      <div class="fj" v-if="!item.isShow">
                        <div style="flex: 1">
                          <img
                            src="../../assets/file/word.svg"
                            v-if="item.ftype == 'doc' || item.ftype == 'docx'"
                          />
                          <img
                            src="../../assets/file/xls.svg"
                            v-if="item.ftype == 'xlsx' || item.ftype == 'xls'"
                          />
                          <img
                            src="../../assets/file/png.svg"
                            v-if="
                              item.ftype == 'jpg' ||
                              item.ftype == 'jpeg' ||
                              item.ftype == 'png'
                            "
                          />
                          <img
                            src="../../assets/file/PDF.svg"
                            v-if="item.ftype == 'pdf'"
                          />
                        </div>
                        <div class="fname" style="flex: 9">
                          <div>
                            {{ item.name }}
                          </div>
                          <div class="word">
                            <span @click="look(item)" class="look">预览</span>
                            <!-- <span class="down" @click="down(item)">下载</span> -->
                            <span @click="del(index, 1)" class="del">删除</span>
                          </div>
                        </div>
                      </div>
                      <!--文件上传进度条-->
                      <div class="uploadprocess" v-else>
                        <div>
                          <div class="jdtext">
                            <div class="uploadname">{{ item.name }}</div>
                            <div class="per">{{ item.curPercentage }}%</div>
                          </div>
                          <el-progress
                            :percentage="item.curPercentage"
                            :show-text="false"
                          ></el-progress>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 收费明细 -->
              <!-- <div
                v-if="
                  form.chargingMethod == '固定收费' ||
                  (form.riskFixed != 0 && form.chargingMethod == '风险收费')
                "
              > -->
              <div v-if="false">
                <div class="divider"></div>
                <div class="top">
                  <div class="icon"></div>
                  <div @click="addCharge">收费明细</div>
                </div>
                <el-row class="addrow">
                  <i class="el-icon-plus" @click="addCharge">添加明细</i>
                </el-row>
                <el-row>
                  <el-table
                    class="party"
                    border
                    :data="form.bcbdTable"
                    style="width: 100%"
                    :header-cell-style="{ textAlign: 'center' }"
                    :cell-style="{ textAlign: 'center' }"
                  >
                    <el-table-column
                      label="款项名称"
                      prop="name"
                      :render-header="addRedStar"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'bcbdTable.' + scope.$index + '.name'"
                          :rules="{
                            required: true,
                            message: '不能为空',
                            trigger: 'blur'
                          }"
                          label-width="0"
                        >
                          <el-input
                            v-model="scope.row.name"
                            placeholder="请输入"
                            clearable
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="应收金额"
                      prop="amount"
                      :render-header="addRedStar"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'bcbdTable.' + scope.$index + '.amount'"
                          :rules="{ validator: Price, trigger: 'change' }"
                          label-width="0"
                        >
                          <el-input
                            v-model="scope.row.amount"
                            placeholder="请输入"
                            clearable
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="约定收款日期" prop="paymentDate">
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'bcbdTable.' + scope.$index + '.paymentDate'"
                          label-width="0"
                        >
                          <el-date-picker
                            style="width: 100%"
                            v-model="scope.row.paymentDate"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="请选择日期"
                            :clearable="false"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </template>
                    </el-table-column>

                    <el-table-column label="备注" prop="remark">
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'bcbdTable.' + scope.$index + '.remark'"
                          label-width="0"
                        >
                          <el-input
                            v-model="scope.row.remark"
                            placeholder="请输入"
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="状态"
                      prop="status"
                      :render-header="addRedStar"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'bcbdTable.' + scope.$index + '.status'"
                          label-width="0"
                          :rules="{
                            required: true,
                            message: '不能为空 ',
                            trigger: 'change'
                          }"
                        >
                          <el-select
                            style="width: 100%"
                            v-model="scope.row.status"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in Bcbd_status"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <span class="copy" @click="copy(scope.row)">复制</span>
                        <span
                          class="bgdel"
                          v-if="form.bcbdTable.length > 1"
                          @click="reduceCharge(scope.$index)"
                          >删除</span
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </div>
              <!-- 用章申请 -->
              <div class="divider"></div>
              <div class="top">
                <div class="icon"></div>
                <div>用章申请</div>
              </div>

              <el-row>
                <el-col :span="24">
                  <el-form
                    class="form"
                    ref="ruleformseal"
                    :model="form.dialogform"
                    :rules="ruleseal"
                    label-width="134px"
                  >
                    <el-col :span="12">
                      <el-form-item label="申请人" prop="applicant">
                        <el-select
                          v-model="form.dialogform.applicant"
                          placeholder="请选择"
                          style="width: 100%"
                          filterable
                          @change="SealChange()"
                        >
                          <el-option
                            v-for="item in Lawyer"
                            :key="item.id"
                            :label="item.nikename"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <!-- <el-form-item label="二次审批人" prop="approver">
                      <el-select
                        v-model="form.dialogform.approver"
                        style="width: 100%"
                        placeholder="请选择"
                        class="select"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in Sealapprove"
                          :key="item.id"
                          :label="item.nikename"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item> -->
                    <el-col :span="12">
                      <el-form-item label="用章事由" prop="reason">
                        <el-input
                          placeholder="请输入"
                          v-model="form.dialogform.reason"
                          disabled
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <!-- <el-form-item label="部门主管" prop="SealLeaders">
                      <el-select
                        style="width: 100%"
                        v-model="form.dialogform.SealLeaders"
                        placeholder="请选择"
                        class="select"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in SealdepLeaders"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item> -->
                    <el-form-item v-show="false" label="附件" prop="file">
                      <el-select
                        v-model="form.dialogform.file"
                        placeholder="请选择"
                        class="input"
                        style="width: 100%"
                        multiple
                        filterable
                      >
                        <el-option
                          v-for="item in FileList"
                          :key="item.uid"
                          :label="item.name"
                          :value="item.uid"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col v-show="false" :span="14">
                  <div style="margin-left: 20px">
                    <div>支持导出的材料：</div>
                    <div style="display: flex">
                      <div>
                        <el-checkbox-group
                          v-model="form.dialogform.checkedCities"
                          @change="handleCheckedCitiesChange"
                        >
                          <el-checkbox
                            style="display: block; padding-top: 20px"
                            v-for="city in form.dialogform.cities"
                            :label="city.name"
                            :key="city.name"
                            >{{ city.name }}</el-checkbox
                          >
                        </el-checkbox-group>
                      </div>
                      <div>
                        <div
                          style="margin-left: 20%; padding-top: 12px"
                          v-for="city in form.dialogform.cities"
                        >
                          <el-select
                            size="mini"
                            v-model="city.stype"
                            placeholder="请选择用章类型"
                            class="yz_input"
                            @change="GetSealLevel()"
                            clearable
                            filterable
                            multiple
                          >
                            <el-option
                              v-for="item in seal"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div></div>
                </el-col>
              </el-row>

              <el-form-item label-width="0">
                <div class="allbtn">
                  <el-button type="warning" @click="saveCaoGao()">
                    保存草稿
                  </el-button>
                  <!-- <el-button type="warning" @click="updateCaoGao()">
                    修改草稿
                  </el-button> -->
                  <el-button
                    type="primary"
                    @click="Post('formref')"
                    :disabled="dianji"
                    >确认新增</el-button
                  >
                  <!-- <el-button type="warning" @click="Save">保存草稿</el-button> -->
                  <el-button class="history" @click="history">返回</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-card>
    </div>

    <el-dialog title="用章申请" center :visible.sync="applyDialog" width="40%">
      <el-form
        class="form"
        label-width="120px"
        :model="form.dialogform"
        :rules="ruleseal"
        ref="ruleformseal"
      >
        <!-- <el-form-item label="申请人" prop="applicant">
          <el-select
            v-model="form.dialogform.applicant"
            placeholder="请选择"
            style="width: 50%"
            filterable
            @change="SealChange()"
          >
            <el-option
              v-for="item in Lawyer"
              :key="item.id"
              :label="item.nikename"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="用章类型" prop="SealType">
          <el-select
            v-model="dialogform.SealType"
            placeholder="请选择"
            style="width: 50%"
            disabled
          >
            <el-option
              v-for="item in seal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="部门审批人" prop="SealLeaders">
          <el-select
            v-model="form.dialogform.SealLeaders"
            placeholder="请先选择申请人"
            style="width: 50%"
            clearable
            filterable
          >
            <el-option
              v-for="item in SealdepLeaders"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二次审批人" prop="approver">
          <el-select
            v-model="form.dialogform.approver"
            placeholder="请先选择申请人"
            style="width: 50%"
            clearable
            filterable
          >
            <el-option
              v-for="item in Sealapprove"
              :key="item.id"
              :label="item.nikename"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用章事由" prop="reason">
          <el-input
            placeholder="请输入"
            v-model="form.dialogform.reason"
            type="text"
            style="width: 50%"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="附件" prop="file">
          <el-select
            v-model="form.dialogform.file"
            placeholder="请选择"
            style="width: 50%"
            multiple
            filterable
            onchange
          >
            <el-option
              v-for="(item, index) in FileList"
              :key="index"
              :label="item.name"
              :value="item.uid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: center" label-width="0">
          <el-button @click="addEnter('ruleformseal')" type="primary"
            >确认</el-button
          >
        </el-form-item> -->
      </el-form>
    </el-dialog>
    <!-- 预览dialog -->
    <el-dialog
      center
      title="文件预览"
      :visible.sync="dialogVisible"
      append-to-body
      class="file-dialog"
      width="70%"
      @close="close"
    >
      <div v-if="isImage">
        <iframe
          id="printIframe"
          :src="imgUrl"
          frameborder="0"
          style="width: 100%; height: 600px"
        />
      </div>
      <!-- word -->
      <!-- //图片不会过大的写法但是有空白 要引入docx-preview-->
      <!-- <div v-if="isWord" ref="word"  style="width: 100%"></div> -->
      <!-- //图片过大，无空白 -->
      <div v-if="isWord" v-html="vHtml" style="width: 100%"></div>
      <!-- excel -->
      <div v-if="isExcel">
        <el-table
          :data="excelData"
          border
          stripe
          :header-cell-style="{ background: '#F5F4F7' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            :resizable="false"
            align="center"
          />
          <el-table-column
            v-for="(value, key, index) in excelData[0]"
            :key="index"
            :prop="key"
            :label="key"
          />
        </el-table>
      </div>
    </el-dialog>

    <!-- 草稿 -->
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="text-align: center">
        检测到当前案件类型有草稿存在，是否基于草稿继续录入？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="caoGaoInput()">基于草稿录入</el-button>
        <el-button type="primary" @click="inputDraftNew()">全新录入</el-button>
        <el-button type="danger" @click="deleteCaoGao()"
          >管理当前案件类型草稿</el-button
        >
        <!-- <el-button type="warning" @click="newInput()"
          >全新录入（清除草稿）</el-button
        > -->
      </span>
    </el-dialog>

    <!-- 草稿选择 -->
    <el-dialog
      title="请选择草稿"
      :visible.sync="cgDialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="text-align: center">
        <el-select
          v-model="cgid"
          class="all-select"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in caoGao"
            :key="item.uuid"
            :label="item.title"
            :value="item.uuid"
          />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cgDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="cgInput(cgid)">确 认</el-button>
        <!-- <el-button type="warning" @click="newInput()"
          >全新录入（清除草稿）</el-button
        > -->
      </span>
    </el-dialog>

    <!-- 草稿管理 -->
    <el-dialog
      title="请选择草稿"
      :visible.sync="scDialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="text-align: center">
        <el-select
          v-model="scid"
          class="all-select"
          clearable
          placeholder="请选择您要删除的草稿"
          multiple
        >
          <el-option
            v-for="item in caoGao"
            :key="item.uuid"
            :label="item.title"
            :value="item.uuid"
          />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="scDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="scCG(scid)">删 除</el-button>
        <!-- <el-button type="warning" @click="newInput()"
          >全新录入（清除草稿）</el-button
        > -->
      </span>
    </el-dialog>


      <!-- 案件冲突 -->
      <el-dialog
      title="冲突"
      :visible.sync="caseConflict"
      width="80%"
      style="text-align: center"
      @close="edit"
    >
    <el-form  ref="formConflict" :model="formConflict" label-width="150px" :rules="rulesConflict">
        <el-row v-if="conflictShow" >
        <el-col :span="8">
          <el-form-item label="二次利冲审批人" prop="conflictApproval" >
              <el-select
              style=" width: 100%;"
                v-model="formConflict.conflictApproval"
                clearable
                placeholder="请选择二次利冲审批人"
                filterable
                
              >
                <el-option
                  v-for="item in OptiomConflict"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="OptiomConflict.length<1&&allConflictCount>0" style="color:red;font-size:18px; margin-bottom:12px;">暂无二次利冲审批人，无法录入</div>
    
      <h2>
        案件冲突<span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方，灰色背景是导入数据)</span
        >
      </h2>
      <el-table
        :data="conflictList"
        style="width: 100% ;height:200"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :row-class-name="tableRowClass"
        max-height="380px"
      >
        <el-table-column prop="code" label="案件编号" width="100">
        </el-table-column>
        <el-table-column prop="title" label="案件名称" width="240">
        </el-table-column>
        <el-table-column prop="litigant" label="当事人" min-width="300">
          <template slot-scope="scope">
            <div v-for="(c,index) in scope.row.litigant " class="litigant-container">
                {{ c.attribute }}：
                <span
                  v-for="(item, index) in c.all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow)
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < c.all.length - 1"
                    >,
                  </span>
                </span>
              </div>
            <!-- <div v-if="scope.row.litigant[0]" class="litigant-container">
              {{ scope.row.litigant[0].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[0].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[0].all.length - 1"
                  >,
                </span>
              </span>
            </div>

            <div v-if="scope.row.litigant[1]" class="litigant-container">
              {{ scope.row.litigant[1].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[1].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[1].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[2]" class="litigant-container">
              {{ scope.row.litigant[2].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[2].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[2].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[3]" class="litigant-container">
              {{ scope.row.litigant[3].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[3].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[3].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[4]" class="litigant-container">
              {{ scope.row.litigant[4].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[4].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[4].all.length - 1"
                  >,
                </span>
              </span>
            </div>
            <div v-if="scope.row.litigant[5]" class="litigant-container">
              {{ scope.row.litigant[5].attribute }}：
              <span
                v-for="(item, index) in scope.row.litigant[5].all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{ color: getRandomColor(item.isClient, item.isshow) }"
                  >{{ item.name }}</span
                >
                <span v-if="index < scope.row.litigant[5].all.length - 1"
                  >,
                </span>
              </span>
            </div> -->
          </template>
        </el-table-column>
        <el-table-column label="冲突对象"> 
            <template slot-scope="scope">
              {{ GetNameIdnumber(scope.row.litigant)}}
            </template>
            </el-table-column>
        <!-- <el-table-column prop="entrustmentTime" label="委托时间" width="150">
          <template slot-scope="scope">
            {{ formatTime(scope.row.entrustmentTime) }}
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <el-button  @click="conflictClick(scope.row)" v-if="!scope.row.isOther" 
              >查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="dialoghasMore" style="text-align: center;">
          <el-button  type="text" @click="dialogshowAllCaseClick" >
            {{ dialogshowAllCase ? '收起' : `查看更多` }}
          </el-button>
        </div>


      <div class="conflic_btn">
        <el-button @click="conflict('formConflict')" type="primary" :disabled="dianji" v-if="!(allConflictCount>0&&OptiomConflict.length<=0)"
          >继续录入</el-button
        >
        <el-button type="warning" @click="edit()">取消录入</el-button>
      </div>
    </el-dialog>
       <!-- 冲突预览 -->
       <el-dialog
      center
      title="预览"
      :visible.sync="isChong"
      append-to-body
      class="file-dialog"
      width="85%"
      @close="closChong"
    >
      <el-form class="form" ref="formrefCT" :model="CTform" label-width="200px">
        <!-- 案件当事人 -->
        <div
          v-if="
            chongCaseType == 1 ||
            chongCaseType == 2 ||
            chongCaseType == 3 ||
            chongCaseType == 4 ||
            chongCaseType == 5 ||
            chongCaseType == 6 ||chongCaseType==9
          "
          style="width: 90%"
        >
          <div class="divider"></div>
          <div class="top">
            <div class="icon"></div>
            <div>案件当事人</div>
          </div>
          <!-- <el-row class="addrow" v-if="bianji == false">
            <el-select v-model="addTableData" clearable filterable>
              <el-option
                v-for="item in ArrtibuteOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button size="mini" type="primary" @click="addParty(null, null)">
              添加当事人
            </el-button>
          </el-row> -->
          <el-row>
            <el-table
              class="party"
              border
              :data="CTform.tableData"
              style="width: calc(100% - 61px);"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                label="属性"
                prop="attribute"
                :render-header="addRedStar"
                width="160"
              >
                <!-- <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="scope.row.attribute"
                    clearable
                    filterable
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in ArrtibuteOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template> -->
              </el-table-column>
              <el-table-column
                label="类型"
                prop="isUnit"
                :render-header="addRedStar"
                width="100"
              >
                <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="scope.row.isUnit"
                    clearable
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="姓名/单位名称"
                prop="name"
                :render-header="addRedStar"
                :show-overflow-tooltip="true"
                min-width="360"
              >
              </el-table-column>
              <el-table-column
                label="委托方"
                prop="isClient"
                :render-header="addRedStar"
                width="80"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    :disabled="bianji"
                    v-model="scope.row.isClient"
                    @change="clientChange(scope.row)"
                  ></el-checkbox>
                </template>
              </el-table-column>

          
            </el-table>
          </el-row>
        </div>

        <div class="text">
          <div style="width: 90%">案件信息：{{ CTform.title }}</div>
        </div>
        <div
          v-if="
            chongCaseType == 1 ||
            chongCaseType == 2 ||
            chongCaseType == 3 ||
            chongCaseType == 4 ||
            chongCaseType == 5 ||
            chongCaseType == 6
          "
          style="width: 90%"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="案件名称" prop="title">
                <el-input
                  v-model="CTform.title"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" v-if="chongCaseType == 3">
              <el-form-item label="公益诉讼" prop="public_welfare">
                <el-select
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.public_welfare"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理机构案号" prop="acceptcode">
                <el-input
                  v-model="CTform.acceptcode"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件编号" prop="code">
                <el-input
                  v-model="CTform.code"
                  placeholder="自动编号"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" v-if="chongCaseType != 4">
              <el-form-item label="法律援助" prop="assist">
                <el-select
                  v-model="CTform.assist"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in Flyz"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案卷状态" prop="ajstatus">
                <el-select
                  v-model="CTform.ajstatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                  @change="inputType(form.ajstatus, null)"
                >
                  <el-option
                    v-for="item in Ajstatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    style="width: 100%"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="10">
              <el-form-item label="受理状态" prop="casestatus">
                <el-select
                  disabled
                  v-model="CTform.casestatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CaseStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                size="small"
                @click="Accept()"
                style="margin-left: 10px; margin-top: 4px"
                v-if="CTform.casestatus == '未受理' && bianji && form.uid"
                type="primary"
                plain
                >点此受理</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" class="date_box">
              <el-form-item label="收案日期" prop="approvaldate">
                <div
                  class="date_box"
                  @mouseover="onMouseOver()"
                  @mouseleave="onMouseleave()"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="CTform.approvaldate"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="系统自动生成"
                    clearable
                    disabled
                  >
                  </el-date-picker>
                  <!-- <i class="el-icon-date" ref="iconDate"></i> -->
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件来源" prop="source">
                <el-input
                  v-model="CTform.source"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理机构" prop="acceptUnit">
                <el-input
                  v-model="CTform.acceptUnit"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案由" prop="cause">
                <el-input
                  v-model="CTform.cause"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="代理律师" prop="leadLawyer">
                <el-select
                  style="width: 100%"
                  v-model="CTform.leadLawyer"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  :multiple-limit="1"
                  @change="LeadLawyerChange(CTform.leadLawyer)"
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="false">
              <el-form-item
                label="委托事项"
                prop="remark"
                v-if="chongCaseType != 2"
              >
                <el-select
                  style="width: 100%"
                  v-model="CTform.remark"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in Entrust"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="chongCaseType == 2"
                label="介入阶段"
                prop="intervene"
              >
                <el-select
                  filterable
                  v-if="CTform.bcz != null"
                  style="width: 100%"
                  v-model="CTform.bcz.intervene"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in Intervene"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="chongCaseType == 2">
            <el-col :span="12" v-if="CTform.result == 1">
              <el-form-item label="刑事风险控制人" prop="criminalrisk">
                <el-select
                  style="width: 100%"
                  v-model="CTform.criminalrisk"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Criminal"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="12"
              v-if="
                chongCaseType != 7 &&
                chongCaseType != 8 &&
                chongCaseType != 14 &&
                chongCaseType != 9 &&
                CTform.result == 1
              "
            >
              <el-form-item label="二次审批人" prop="level">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.level"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  multiple
                  :multiple-limit="1"
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="代理律师" prop="coCounsel">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.coCounsel"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="CTform.result == 1">
            <el-form-item label="部门主管" prop="caseLeaderscase">
              <el-select
                filterable
                placeholder="请选择"
                clearable
                v-model="CTform.caseLeaderscase"
                @change="bmzgChange"
              >
              
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </div>

        <div v-else style="width: 90%">
          <el-row>
            <el-col :span="24">
              <el-form-item label="项目名称" prop="title">
                <el-input v-model="CTform.title" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="受理机构案号" prop="acceptcode">
              <el-input
                v-model="CTform.acceptcode"
                placeholder="请输入"
                clearable
                :disabled="bianji"
              ></el-input>
            </el-form-item>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="项目概要" prop="cause">
                <el-input
                  v-model="CTform.cause"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="案件编号" prop="code">
                <el-input
                  v-model="CTform.code"
                  placeholder="自动编号"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="案卷状态" prop="ajstatus" v-if="chongCaseType != 12 && chongCaseType !=13">
                <el-select
                  v-model="CTform.ajstatus"
                  placeholder="请选择"
                  class="input"
                  style="width: 100%"
                  disabled
                  @change="inputType(form.ajstatus, null)"
                >
                  <el-option
                    v-for="item in Ajstatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="破产案件类型" prop="bcz.projecttype" v-if="chongCaseType == 12">
                    <el-select
                      style="width: 100%"
                      v-model="CTform.bcz.projecttype"
                      placeholder="请选择"
                      class="select"
                      disabled
                    >
                      <el-option
                        v-for="item in ProjectType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="12">
              <el-form-item label="受理状态" prop="casestatus">
                <el-select
                  disabled
                  v-model="CTform.casestatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CaseStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                size="small"
                @click="Accept()"
                style="margin-left: 20px"
                v-if="CTform.casestatus == '未受理' && bianji && CTform.uid"
                type="primary"
                plain
                >点此受理</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="项目合伙人" prop="partner">
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.partner"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="底稿资料" prop="draft">
                <el-select
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.draft"
                  placeholder="请选择"
                  class="select"
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in Draft"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 一般非诉项目、单独出具律师意见审批书、单独出具律师函没有二次审批人 -->
          <el-row
            v-if="
              chongCaseType != 7 &&
              chongCaseType != 8 &&
              chongCaseType != 14 &&
              chongCaseType != 9 &&
              (form.result == 1 || bianji == false)
            "
            style="width: 90%"
          >
            <el-col :span="14">
              <el-form-item label="二次审批人" prop="level">
                <el-select
                  style="width: 100%"
                  v-model="CTform.level"
                  class="select"
                  multiple
                  :multiple-limit="1"
                  disabled
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="divider"></div>
          <el-row>
            <el-col :span="14" class="date_box">
              <el-form-item label="立项日期" prop="approvaldate">
                <el-date-picker
                  style="width: 100%"
                  v-model="CTform.approvaldate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="系统自动生成"
                  disabled
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="项目来源" prop="source">
                <el-input
                  v-model="CTform.source"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item
                :label="chongCaseType == 10 ? '代理机构' : '受理机构'"
                prop="acceptUnit"
                v-if="chongCaseType == 10"
              >
                <el-input v-model="CTform.acceptUnit" disabled></el-input>
              </el-form-item>
              <el-form-item
                :label="chongCaseType == 12 ? '管辖法院' : '受理机构'"
                v-if="chongCaseType != 10"
              >
                <el-input v-model="CTform.acceptUnit" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :span="10"
              v-if="
                chongCaseType == 7 ||
                chongCaseType == 8 ||
                chongCaseType == 14 ||
                chongCaseType == 9 ||
                chongCaseType == 11
              "
            >
              <el-form-item label="项目分类" prop="classification">
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.classification"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType == 10">
              <el-form-item label="项目类型" prop="projecttype">
                <el-select
                  v-if="CTform.bcz != null"
                  style="width: 100%"
                  v-model="CTform.bcz.projecttype"
                  disabled
                >
                  <el-option
                    v-for="item in Projecttype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType == 12">
              <el-form-item label="案件级别" >
                <el-select style="width: 100%" v-model="CTform.bcz.caselevel" placeholder="请选择" class="select" disabled>
                    <el-option v-for="item in Level" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item
                :label="chongCaseType == 10 ? '服务律师' : '代理律师'"
                prop="leadLawyer"
              >
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.leadLawyer"
                  class="select"
                  multiple
                  :multiple-limit="1"
                  @change="LeadLawyerChange(CTform.leadLawyer)"
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="代理律师" prop="coCounsel">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.coCounsel"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-if="
              (chongCaseType == 7 ||
                chongCaseType == 8 ||
                chongCaseType == 14 ||
                chongCaseType == 9) &&
              CTform.result == 1
            "
          >
            <el-col :span="14">
              <el-form-item label="风控委" prop="level">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.level"
                  class="select"
                  multiple
                  :multiple-limit="2"
                  disabled
                >
                  <el-option
                    v-for="item in FKW"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="CTform.result == 1">
            <el-form-item label="部门主管" prop="caseLeaderscase">
              <el-select
                filterable
                style="width: 100%"
                v-model="CTform.caseLeaderscase"
                placeholder="请选择"
                class="select"
                clearable
                @change="bmzgChange"
              >
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <!-- 与其他法律服务有关的招投标项目栏独有字段 -->
          <div v-if="chongCaseType == 10">
            <el-row>
              <el-col :span="14">
                <el-form-item label="开放时间" prop="opentime">
                  <el-date-picker
                    v-if="CTform.bcz != null"
                    style="width: 100%"
                    v-model="CTform.bcz.opentime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采购方式" prop="procuremethod">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.procuremethod"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item label="预算金额" prop="budgetmoney">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.budgetmoney"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采购编号" prop="procurecode">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.procurecode"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 专项服务合同独有字段 -->
          <div v-if="chongCaseType == 11">
            <el-row>
              <el-col :span="14">
                <el-form-item label="合同服务类型" prop="contracttype">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.contracttype"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="服务期限" prop="servicetime">
                  <el-date-picker
                    v-if="CTform.bcz != null"
                    style="width: 100%"
                    v-model="CTform.bcz.servicetime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-if="chongCaseType == 12">
            <el-row>
                <el-col :span="14">
                  <el-form-item label="项目负责人" >
                    <el-input v-model="CTform.bcz.porjectleader" placeholder="请输入" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="委托人摇号" >
                    <el-input v-model="CTform.bcz.lottery" placeholder="请输入" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="14">
                  <el-form-item label="管理人账号" >
                    <el-select style="width: 100%" v-model="CTform.bcz.administrator" placeholder="请选择"
                      class="select" disabled>
                      <el-option v-for="item in Administrator" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!CTform.bcz.administrator">
                  <el-col :span="14">
                    <el-form-item label="开户账号" >
                      <el-input v-model="CTform.bcz.account" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="开户银行" >
                      <el-input v-model="CTform.bcz.bank" placeholder="请输入" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
          </div>
          <div class="divider"></div>

          <el-row v-if="chongCaseType!=9">
            <el-col :span="14">
              <el-form-item v-if="chongCaseType!=12"
                :label="chongCaseType == 10 ? '采购单位' : '客户名称'"
                prop="bcz.procureunit"
              >
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.procureunit"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="债务人名称" prop="bcz.debtorName" v-if="chongCaseType==12">
                      <el-input
                        v-model="CTform.bcz.debtorName"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
            </el-col>
            <el-col :span="10"> <el-form-item label="身份证号/社会信用代码/护照号" prop="bcz.idnumber" v-if="chongCaseType!=10">
                      <el-input
                        v-model="CTform.bcz.idnumber"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

    <!-- 加载中组件 -->
    <!-- <loading-overlay v-if="isLoading"></loading-overlay> -->
  </div>
</template>
  
<script>
import {
  BidDetail,
  BankruptAdd,
  GetDepartmentLeaders
} from '../../api/bankrupt'
import { user } from '../../api/seal' //测试
import { requestDownLoadFile, requestReview } from '../../api/counsel.js'
import mammoth from 'mammoth'
import { caseConflictApi,allCaseApi,ConflictMember,GetAllLitigant} from '../../api/case'
// 定义blob对应的type
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
const docx = require('docx-preview')
const XLSX = require('xlsx')
export default {
  name: 'bankinput',

  data() {
    var newPrice = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    var Price = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value <= 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    var NewPrice = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    var debtor = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (value && value <= 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (value && !price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    var riskRatio = (rule, value, callback) => {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value < 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (value > 100) {
        callback(new Error('不能大于100'))
      } else if (!price.test(value)) {
        callback(new Error('最多输入两位小数')) //防止输入多个小数点
      } else {
        callback()
      }
    }
    return {
      // 法律援助
      Flyz: [
        { label: '是', value: true },
        { label: '否', value: false }
      ],
      // 单位/个人
      typeOptions: [
        { value: true, label: '个人' },
        { value: false, label: '单位' }
      ],
      ProjectType:[{label:"重整案件",value:"重整案件"},{label:"预重整",value:"预重整"},{label:"公益案件",value:"公益案件"}],
      bankshow:true,
      ruleseal: {
        applicant: { required: true, message: '不能为空 ', trigger: 'change' },
        approver: { required: true, message: '不能为空 ', trigger: 'change' },
        SealType: { required: true, message: '不能为空 ', trigger: 'change' },
        reason: { required: true, message: '不能为空 ', trigger: 'change' },
        // file: { required: true, message: '不能为空 ', trigger: 'change' },
        SealLeaders: { required: true, message: '不能为空 ', trigger: 'change' }
      },
      isLoading: false, // 是否处于加载状态
      BidId: '', //投标案件的id
      form: {
        title: '', //名称
        cause: '', //概要
        code: '', //编号
        casestatus: '', //案卷状态
        approve: '',
        source: '', //案件来源
        acceptUnit: '', //管辖法院
        acceptCode: '',
        departmentLeaders: '', //部门审批人
        leadLawyer: [], //服务律师
        coCounsel: [], //代理律师
        chargingMethod: '固定收费',
        amountOfSubject: "",
        introduction: '',
        remark: '',
        fixed: null,
        riskFixed: 0,
        riskRatio: 0,
        sealType: '',
        BiddingSchemes: [],
        acceptanceRuling: [],
        administratorDecision: [],
        FreeFile: [],
        annex: [],
        extInfo: {
          partner: '', //合伙人
          draft: '', //底稿资料
          caselevel: '', //案件等级
          porjectleader: '',
          administrator: false,
          account: '',
          bank: '',
          lottery: '',
          debtorName: '',
          asset: '',
          debenture: '',
          projecttype:'',
          idnumber:'',
        },
        bcbdTable: [
          // 收费明细
          {
            name: '',
            amount: null,
            paymentDate: null,
            remark: '',
            status: null
          }
        ],

        dialogform: {
          //用章
          applicant: '',
          approver: '',
          file: [],
          reason: '申请立项',
          SealType: '',
          SealLeaders: '',

          checkedCities: [],
          cities: null
        },

        draftFormId: null,
        draftFormType: null,
        uuid: null
      },

      text: '21',
      Date: [
        { value: '1', label: '一月之内' },
        { value: '2', label: '二月之内' },
        { value: '3', label: '三月之内' }
      ],
      formrules: {
        chargingMethod: {
          required: true,
          message: '不能为空 ',
          trigger: 'change'
        },
        postTime: { required: true, message: '不能为空 ', trigger: 'change' },
        title: { required: true, message: '不能为空 ', trigger: 'change' },
        cause: { required: true, message: '不能为空 ', trigger: 'change' },
        // acceptCode:{ required: true, message: '不能为空 ', trigger: 'change'},
        acceptUnit: { required: true, message: '不能为空 ', trigger: 'change' },
        approve: { required: true, message: '不能为空 ', trigger: 'change' },
        leadLawyer: { required: true, message: '不能为空 ', trigger: 'change' }, //服务律师
        casestatus: { required: true, message: '不能为空 ', trigger: 'change' },
        sealType: { required: true, message: '不能为空 ', trigger: 'change' },
        // fixed: [
        //   { required: true, message: '不能为空 ', trigger: 'change' },
        //   { validator: Price, trigger: 'change' }
        // ],
        // amountOfSubject: [
        //   { required: true, validator: NewPrice, trigger: 'change' }
        // ], //投标价格
        //定额收费金额
        // riskFixed: [{ required: true, validator: NewPrice, trigger: 'change' }], //半风险中的定额收费金额
        riskRatio: [{ required: true, validator: NewPrice, trigger: 'change' }, { validator: riskRatio, trigger: 'change' }], //风险收费比例
     
        extInfo: {
          asset: [{ validator: debtor, trigger: 'change' }],
          debenture: [{ validator: debtor, trigger: 'change' }],
          projecttype:[{ required: true, message: '不能为空 ', trigger: 'change' }],
          debtorName:[{ required: true, message: '不能为空 ', trigger: 'change' }],
          idnumber:[{ required: true, message: '不能为空 ', trigger: 'change' }],
        },
        // BiddingSchemes: [
        //   { required: true, message: '不能为空 ', trigger: 'change' }
        // ],
        // acceptanceRuling: [
        //   { required: true, message: '不能为空 ', trigger: 'change' }
        // ],
        // administratorDecision: [
        //   { required: true, message: '不能为空 ', trigger: 'change' }
        // ],
        departmentLeaders: {
          required: true,
          message: '不能为空 ',
          trigger: 'change'
        },
        FreeFile: [{ required: true, message: '不能为空 ', trigger: 'change' }]
      },

      CaseStatus: [
        { label: '受理', value: '受理' },
        { label: '未受理', value: '未受理' }
      ], //案件状态
      Draft: [
        { label: '已归档', value: true },
        { label: '未归档', value: false }
      ], //底稿资料
      approve: [], //二次审批人
      depLeaders: [], //部门领导人
      SealdepLeaders: [], //用章申请部门领导人
      Sealapprove: [], //用章二次审批人
      Lawyer: [], //代理律师
      selectedLawyer: [], //被选择的律师
      Level: [
        { value: 1, label: '一级' },
        { value: 2, label: '二级' },
        { value: 3, label: '三级' }
      ], //案件级别
      Administrator: [
        { value: false, label: '未开设' },
        { value: true, label: '已开设' }
      ], //管理人
      chargestatus: [
        { value: '免费', label: '免费' },
        { value: '固定收费', label: '固定收费' },
        { value: '风险收费', label: '风险收费' }
      ], //收费情况
      Method: [
        { value: 0, label: '分期' },
        { value: 1, label: '不分期' }
      ], //收费方式
      seal: [
        { label: '合同章', value: 'contract_seal' },
        { label: '法人章', value: 'corporate_seal' },
        { label: '公章', value: 'official_seal' }
        // { label: '公章+法人章', value: 'official_corporate_seal' },
        // { label: '合同章+法人章', value: 'contract_corporate_seal' },
        // { label: '法律意见书专用章', value: 'law_seal' },
        // { label: '律师函专用章', value: 'legal_letter_seal' }
      ], //合同用章
      Bcbd_status: [
        //收费明细状态
        { value: 0, label: '已完成' },
        // { value: 1, label: '已禁用' },
        { value: 2, label: '已提醒' },
        { value: 3, label: '待提醒' }
        // { value: -1, label: '已删除' },
      ],
      FileList1: [], //投标方案
      FileList2: [], //法院的受理裁定书
      FileList3: [], //管理人的决定书
      FileList4: [], //附件
      FileList5: [],
      applyDialog: false, //申请用章弹出框
      FileList: [], //申请用章附件

      imgUrl: '', //图片路径
      sheetNames: null, //从数据中获取到的sheet页数组
      dialogVisible: false,
      imgType: ['jpg', 'jpeg', 'png', 'pdf'],
      excelHtml: '',
      excelData: null,
      vHtml: null,
      isExcel: false,
      isWord: false,
      isImage: false,
      times: 1, //回退次数
      centerDialogVisible: false,
      cgDialogVisible: false,
      caoGao1: false,
      newcaoGao1: false,
      caoGao: [],
      cgid: null,
      my: false,
      scDialogVisible: false,
      scid: null,

      selectedSealType: [],
      dianji: false,

      //案件冲突
      caseConflict:false,
      conflictList: [], //案件冲突列表
     
      
      isChong:false,
      CTform: {
        casestatus: null,
        acceptcode: null, // 受理机构案号/受理案号
        id: null,
        assist: null, //法律援助(true是，false否）
        typeId: null, // 录入类型
        title: null, //案件名称
        code: null, //案件编号
        ajstatus: null, //案卷状态(节点名称)***
        approvaldate: null, //收案日期(委托时间)***
        source: null, // 项目概要/案件来源
        acceptUnit: null, //受理机构(受理单位)
        cause: null, //案由/项目来源
        leadLawyer: [], //代理律师(主办律师)***List
        remark: null, //委托事项
        level: [], //二次审批人/风控委
        coCounsel: [], //代理律师 List
        biddingSchemes: [], //合同上传 List
        chujuFiles: [], // 拟出具文件
        ordinaryFiles: [], //普通附件 List
        invoiceFile: [], //发票
        linkId: null, // 关联案件ID*** Guid
        status: null,
        caseLeaders: null, // 案件部门主管
        link: [],
        criminalrisk: null, //刑事风险控制人  Guid
        result: null,
        bs_Result: null,
        // 不复存在的
        bcz: {
          client: null, //委托人
          intervene: null, //介入阶段(0全程，1侦查阶段，2审查起诉阶段，3审判阶段）

          public_welfare: null, //是否是公益诉讼

          //------全都是<非诉案件>------
          partner: null, //项目合伙人
          draft: null, //底稿资料
          classification: null, //项目分类
          projecttype: null, //项目类型***  Guid
          opentime: null, //开放时间
          procuremethod: null, //采购方式
          budgetmoney: null, //预算金额
          procurecode: null, //采购编号
          contracttype: null, //合同服务类型
          servicetime: null, //服务期限
          procureunit: null, //采购单位/客户名称
          idnumber:null,
        },
        // 案件当事人
        tableData: [
          {
            id: null,
            isUnit: null, //是否是个人***
            name: null, //姓名/单位名称***
            IsClient: false, //是否委托人***
            attribute: null, //当事人属性（原告被告等）***
            count: 1
          }
        ]
      },
      bianji: true, // 只允许不通过的时候编辑（false可编辑，true不能）
      // 案卷状态
      Ajstatus: [
        { label: '一审', value: '一审' },
        { label: '二审', value: '二审' },
        { label: '再审', value: '再审' },
        { label: '破产申报', value: '破产申报' },
        { label: '再审听证', value: '再审听证' },
        { label: '行政复议', value: '行政复议' },
        { label: '首次执行', value: '首次执行' },
        { label: '恢复执行', value: '恢复执行' },
        { label: '执行异议', value: '执行异议' },
        { label: '仲裁阶段', value: '仲裁阶段' },
        { label: '侦查阶段', value: '侦查阶段' },
        { label: '审查起诉', value: '审查起诉' },
        { label: '受理', value: '受理' },
        { label: '未受理', value: '未受理' },
        { label: '无', value: '无' }
      ],
      // 公益诉求
      options: [
        { value: 0, label: '是' },
        { value: 1, label: '否' }
      ],
      chongCaseType:"",
      

      //二次利冲审批人
      conflictShow:false,//是否显示选择框，若无利冲或只有一个审批人的情况下不显示
      allConflictCount:0,//总冲突数量
      OptiomConflict:[],//所有二次利冲审批人
      formConflict:{
        conflictApproval:null,
      },
      rulesConflict:{
        conflictApproval: [{ required: true, message: '不能为空', trigger: 'blur' }],
      },


      dialogshowAllCase:false,//是否显示全部冲突案件
      dialoghasMore:false,
      dialogallConflictCase:[],//所有的冲突案件

      AllLit:[],
      idnumbers:[]
    }
  },

  methods: {
    GetLit(){//获取所有当事人
      GetAllLitigant({}).then((res)=>{
        if(res.data.status=='success'){
          this.AllLit=res.data.data
        }else{
          this.AllLit=[]
        }
       })
    },
   //客户名称
   querySearchName(queryString, cb) {
     
     var restaurants =[]
     if(queryString.length>4){
      restaurants = this.AllLit;
     }
     var results = queryString ? restaurants.filter(this.createFilterName(queryString)) : restaurants;
   
     if(results.length==0){
      this.idnumbers=[];
      
     }
        // 调用 callback 返回建议列表的数据
     cb(results);
    },
    createFilterName(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
  handleSelectName(item){
    this.form.extInfo.debtorName=item.value
    const unique1 = [...new Set(item.idnumber)];
    this.idnumbers = unique1;
    if(unique1&&unique1.length>=1){
      this.form.extInfo.idnumber=unique1[0]
    }
  },
    GetNameIdnumber(data){
      const filtered = data.flatMap(item => 
        item.all
          .filter(person => person.isshow)
          .map(person => ({ 
            name: person.name, 
            idnumber: person.idnumber 
          }))
      );

      // 步骤2：格式化为"姓名(身份证号)"格式，多个用逗号隔开
      const resultStr = filtered.map(item => {
        // 处理身份证号为空或不存在的情况，显示"无"
        const idStr = item.idnumber || "无";
        return `${item.name}(${idStr})`;
      }).join(',');
      return resultStr
    },
    //禁止顿号的输入
    filterComma(row) {
      if (row.debtorName && row.debtorName.includes('、')) {
        row.debtorName = row.debtorName.replace(/、/g, '');
      }
      if (row.idnumber && row.idnumber.includes('、')) {
        row.idnumber = row.idnumber.replace(/、/g, '');
      }
    },
    dialogshowAllCaseClick(){
      if(this.dialogshowAllCase){
        this.dialogshowAllCase=false
        this.conflictList = this.dialogallConflictCase.filter(item => item.conId == 1)//所有有冲突的案件
        if(this.conflictList.length==0){//没有冲突案件
          this.conflictList.push(this.dialogallConflictCase[0])
        } 
       
      }else{
        this.conflictList=this.dialogallConflictCase
        this.dialogshowAllCase=true
      }
    },
    async GetConflictMember(){
      ConflictMember().then((res) => {
        if(res.data.status=="success"){
          this.OptiomConflict=res.data.data
          this.caseConflict = true
                 
          if(this.OptiomConflict.length>1){
            this.conflictShow=true
          }else if(this.OptiomConflict.length==1){
             this.conflictShow=false
             this.formConflict.conflictApproval=this.OptiomConflict[0].value
          }
            console.log( this.conflictShow)
        }else{
          this.$message.error(res.data.message)
        }
      })
    },
      // 案件当事人背景颜色
      tableRowClassName({ row, rowIndex }) {
      console.log(row.isClient)
      if (row.isClient||row.isClient) {
        return 'isclient-row'
      } else {
        return ''
      }
    },
    closChong() {
      this.isChong = false
    },
    NewPrice(rule, value, callback) {
      var price = /^\d+(\.\d{0,2})?$/
      if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    },
    handleCheckedCitiesChange() {
      // console.log(this.form.dialogform.checkedCities)
    },
    user(id) {
      user({}).then((res) => {
        if (res.data.status == 'success') {
          this.Lawyer = res.data.data.filter((item) => item.status == 0||item.status == 6)
          if (this.Lawyer.length > 0) {
            if (id == 'bank') {
              this.form.leadLawyer.push(this.Lawyer[0].uid)
              this.form.dialogform.applicant = this.Lawyer[0].uid
              this.selectChange('1')
              this.SealChange()
            }
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    GetDepartmentLeaders(id, type) {
      //获取部门审批人
      GetDepartmentLeaders({ Id: id }).then((res) => {
        if (res.data.status == 0) {
          if (type == 'seal') {
            //用章的部门审批人
            this.SealdepLeaders = res.data.data
            var index = this.SealdepLeaders.findIndex((item) => {
              return item.value == this.form.dialogform.SealLeaders
            })
            if (index == -1) {
              //不存在，清空
              this.form.dialogform.SealLeaders = ''
            }
          }
          if (type == 'case') {
            //案件的部门审批人
            this.depLeaders = res.data.data
            var index = this.depLeaders.findIndex((item) => {
              return item.value == this.form.departmentLeaders
            })
            // console.log("index:"+index)
            if (index == -1) {
              //不存在，清空
              this.form.departmentLeaders = ''
            }
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          if (type == 'seal') {
            //用章的部门审批人
            this.SealdepLeaders = []
            this.form.dialogform.SealLeaders = ''
          }
          if (type == 'case') {
            this.depLeaders = []
            this.form.departmentLeaders = ''
          }
          this.$message.error(res.data.message)
        }
      })
    },
    GetApprove() {
      //获取案件二次审核人
      user({
        Id: this.form.leadLawyer[0],
        apporver: 'case_00000000-0011-0011-0012-000000000000'
      }).then((res) => {
        if (res.data.status == 'success') {
          this.approve = res.data.data
          var index = this.approve.findIndex((item) => {
            return item.id == this.form.approve
          })
          if (index == -1) {
            //不存在，清空二次审批人
            this.form.approve = ''
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    GetSealApprove() {
      var newSeal = []
      this.form.dialogform.cities.forEach((value) => {
        if (value.stype.length > 0) {
          newSeal.push(value.stype.join(','))
        }
      })
      var uniqueArr = [
        ...new Map(newSeal.map((item) => [item, item])).values()
      ].join(',')
      //获取用章二次审核人
      user({
        Id: this.form.dialogform.applicant,
        apporver: uniqueArr
      }).then((res) => {
        if (res.data.status == 'success') {
          this.Sealapprove = res.data.data
          var index = this.Sealapprove.findIndex((item) => {
            return item.id == this.form.dialogform.approver
          })
          if (index == -1) {
            //不存在，清空二次审批人
            this.form.dialogform.approver = ''
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
      })
    },
    SealChange() {
      this.GetSealApprove()
      this.GetDepartmentLeaders(this.form.dialogform.applicant, 'seal')
    },
    Save() {},
    history() {
      this.$router.go(-this.times)
    },
    close() {
      if (this.imgUrl) {
        this.times = this.times + 1
        this.imgUrl = ''
      }
    },
    handlerError(data) {
      let enc = new TextDecoder('utf-8')
      var res = enc.decode(new Uint8Array(data))
      var jsonData = JSON.parse(res)
      //  console.log(jsonData)
      //  console.log(jsonData.status)
      if (
        jsonData.status == '401' ||
        jsonData.status == '402' ||
        jsonData.status == '403'
      ) {
        this.$message.error(jsonData.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
      // this.$message.error(enc.decode(new Uint8Array(res.data)))
    },
    // 预览文件
    look(item) {
      let fileType = item.ftype
      this.isLoading = true
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        if (this.imgType.includes(fileType)) {
          this.dialogVisible = true
          this.isWord = false
          this.isExcel = false
          this.isImage = true
          //Image PDF
          requestDownLoadFile({ Id: item.uid }).then((res) => {
            if (res.data.type && res.data.type.includes('application/json')) {
              this.handlerResponseError(res.data)
            } else {
              const blob = new Blob([res.data], { type })
              this.imgUrl = this.getObjectURL(blob)
            }
          })
          // } else if (fileType === 'doc' || fileType === 'docx') {
        } else if (fileType === 'docx') {
          this.dialogVisible = true
          var vm = this
          //WORD
          this.isWord = true
          this.isExcel = false
          this.isImage = false
          requestReview({ Id: item.uid }).then((res) => {
            // docx.renderAsync(data, this.$refs.word) // 渲染到页面预览

            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              mammoth
                .convertToHtml({ arrayBuffer: new Uint8Array(res.data) })
                .then(function (resultObject) {
                  vm.$nextTick(() => {
                    // document.querySelector("#wordView").innerHTML =
                    //   resultObject.value;
                    vm.vHtml = resultObject.value
                  })
                })
            }
          })
        } else if (fileType === 'xls' || fileType === 'xlsx') {
          this.dialogVisible = true
          //EXCEL
          requestReview({ Id: item.uid }).then((res) => {
            if (
              res.headers['content-type'] &&
              res.headers['content-type'].includes('application/json')
            ) {
              this.handlerError(res.data)
            } else {
              this.isExcel = true
              this.isWord = false
              this.isImage = false
              const workbook = XLSX.read(new Uint8Array(res.data), {
                type: 'array'
              }) // 解析数据
              var worksheet = workbook.Sheets[workbook.SheetNames[0]] // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
              // this.excelHtml = XLSX.utils.sheet_to_html(worksheet) // 渲染成html
              const sheet2JSONOpts = {
                /** Default value for null/undefined values */
                defval: '' // 给defval赋值为空的字符串,不然没值的这列就不显示
              }
              // 渲染成json
              this.excelData = XLSX.utils.sheet_to_json(
                worksheet,
                sheet2JSONOpts
              )
            }
          })
        } else {
          this.$message.error('不支持此文件预览')
        }
        this.isLoading = false
        this.dianji = false
      } else {
        this.isLoading = false
        this.dianji = false
        this.$message.error('不支持此文件预览')
      }
    },
    getObjectURL(file) {
      let url = null
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file)
        } catch (error) {
          console.log(error)
        }
      }
      return url
    },
    async down(item) {
      //下载
      // console.log(item)
      this.isLoading = true
     
      const res = await requestDownLoadFile({
        Id: item.uid
      })
      if (res.data.type && res.data.type.includes('application/json')) {
        this.handlerResponseError(res.data)
      } else {
        this.getDownLoadFile(res.data, res['headers']['content-type'], item)
      }
    },
    handlerResponseError(data) {
      const _this = this
      const fileReader = new FileReader()
      fileReader.onload = function () {
        try {
          const jsonData = JSON.parse(fileReader.result) // 说明是普通对象数据，后台转换失败
          if (
            jsonData.status == '401' ||
            jsonData.status == '402' ||
            jsonData.status == '403'
          ) {
            _this.$message.error(jsonData.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            _this.$router.push('/login')
          }
          // dosomething……
        } catch (err) {
          // 解析成对象失败，说明是正常的文件流
          console.log('success...')
        }
      }
      this.isLoading = false
      this.dianji = false
      fileReader.readAsText(data)
    },
    getDownLoadFile(blobFile, contenttype, row) {
      let downloadBolb = null
      let fileType = row.ftype
      // 后台接口方法url：接口地址，data给后台传的参数
      let type = ''
      if (fileType) {
        type = fileTypeMap[fileType]
        downloadBolb = new Blob([blobFile], {
          type: type
        })
        // 下载文件
        this.downloadFile(downloadBolb, row.name + '.' + fileType)
        this.isLoading = false
        this.dianji = false
        return downloadBolb
      }
    },
    downloadFile(blob, fileName) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      // 字符内容转变成blob地址
      eleLink.href = this.getObjectURL(blob)
      // 自动触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
      // 然后移除
      document.body.removeChild(eleLink)
    },

    del(index, type) {
      // console.log('删除')
      if (type == 1) {
        this.FileList1.splice(index, 1)
      } else if (type == 2) {
        this.FileList2.splice(index, 1)
      } else if (type == 3) {
        this.FileList3.splice(index, 1)
      } else if (type == 4) {
        this.FileList4.splice(index, 1)
      } else if (type == 5) {
        this.FileList5.splice(index, 1)
      }
      this.FileList = this.FileList1.concat(
        this.FileList2.concat(this.FileList3.concat(this.FileList4))
      )
      this.form.dialogform.file = []
    },
    //添加收费明细
    addCharge() {
      // console.log("添加")
      this.form.bcbdTable.push({
        name: '',
        amount: null,
        paymentDate: null,
        remark: '',
        status: null
      })
    },
    // 减少收费明细
    reduceCharge(index) {
      this.form.bcbdTable.splice(index, 1)
    },
    copy(row) {
      this.form.bcbdTable.push({
        name: row.name,
        amount: row.amount,
        paymentDate: row.paymentDate,
        remark: row.remark,
        status: row.status
      })
      // var copy = "";
      // if(row.name){
      //   copy += "款项名称："+row.name+"\n"
      // }
      // if(row.amount){
      //   copy +="应收金额："+row.amount+"\n"
      // }
      // if(row.paymentDate){
      //   copy +="约定收款日期："+ this.handleTime(row.paymentDate,"yyyy-MM-dd")+"\n"
      // }
      // if(row.remark){
      //   copy +="备注："+row.remark+"\n"
      // }
      // navigator.clipboard.writeText(copy).then(() => {
      //   this.$message({
      //     message: '复制成功',
      //     type: 'success'
      //   });
      // });
    },
    handleRemove(file, type) {
      //删除附件
      if (type == 1) {
        this.FileList1.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 2) {
        this.FileList2.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 3) {
        this.FileList3.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 4) {
        this.FileList4.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      } else if (type == 5) {
        this.FileList5.forEach((value, index, array) => {
          //删除上传失败的文件
          // console.log(file.uid)
          if (value.uid == file.uid) {
            array.splice(index, 1)
          }
        })
      }
      this.FileList = this.FileList1.concat(
        this.FileList2.concat(this.FileList3.concat(this.FileList4))
      )
    },
    // handlePreview(file) {
    //   console.log(file);
    // },
    // handleExceed(files, fileList) {
    //   this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    // },
    // beforeRemove(file, fileList) {//删除触发
    //   return this.$confirm(`确定移除 ${ file.name }？`);
    // },
    onProgress(event, file, type) {
      let num = ((event.loaded / event.total) * 100) | 0 //百分比
      if (type == 1) {
        this.FileList1.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 2) {
        this.FileList2.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 3) {
        this.FileList3.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      } else if (type == 4) {
        this.FileList4.forEach((value) => {
          if (value.uid == file.uid) {
            value.curPercentage = num
          }
        })
      }
      this.FileList = this.FileList1.concat(
        this.FileList2.concat(this.FileList3.concat(this.FileList4))
      )
    },
    onChange(file, type) {
      if (file.status == 'fail') {
        if (type == 1) {
          this.FileList1.forEach((value, index, array) => {
            //删除上传失败的文件
            // console.log(file.uid)
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 2) {
          this.FileList2.forEach((value, index, array) => {
            //删除上传失败的文件
            // console.log(file.uid)
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 3) {
          this.FileList3.forEach((value, index, array) => {
            //删除上传失败的文件
            // console.log(file.uid)
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 4) {
          this.FileList4.forEach((value, index, array) => {
            //删除上传失败的文件
            // console.log(file.uid)
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        } else if (type == 5) {
          this.FileList5.forEach((value, index, array) => {
            //删除上传失败的文件
            // console.log(file.uid)
            if (value.uid == file.uid) {
              array.splice(index, 1)
            }
          })
        }
        return this.$message.error(file.name + '上传失败')
      }
      this.FileList = this.FileList1.concat(
        this.FileList2.concat(this.FileList3.concat(this.FileList4))
      )
    },
    beforeUpload(file, type) {
      //上传验证
      this.uploadname = file.name
      var typefile = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      // console.log(typefile)
      var filename = file.name.substring(0, file.name.lastIndexOf('.'))
      if (type == 1) {
        this.FileList1.push({
          uid: file.uid,
          name: filename,
          ftype: typefile,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else if (type == 2) {
        this.FileList2.push({
          uid: file.uid,
          name: filename,
          ftype: typefile,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else if (type == 3) {
        this.FileList3.push({
          uid: file.uid,
          name: filename,
          ftype: typefile,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else if (type == 4) {
        this.FileList4.push({
          uid: file.uid,
          name: filename,
          ftype: typefile,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      } else if (type == 5) {
        this.FileList5.push({
          uid: file.uid,
          name: filename,
          ftype: typefile,
          isShow: true,
          curPercentage: 0
        }) //添加上传的文件
      }

      this.FileList = this.FileList1.concat(
        this.FileList2.concat(this.FileList3.concat(this.FileList4))
      )
      const isImg =
        '.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf,.wps,.WPS'.indexOf(
          typefile
        ) >= 0
      const isMaxSize = file.size / 1024 / 1024 < 50
      if (!isImg) {
        this.$message.error(
          '只能上传jpg,jpeg,png,doc,docx,xls,xlsx,pdf格式的文件'
        )
      }
      if (!isMaxSize) {
        this.$message.error('上传大小不能超过50MB！')
      }
      return isImg && isMaxSize
    },
    uploadSuccess(res, file, fileList, type) {
      //招标文件上传成功
      // var fileid = this.FileList1.map(item => Object.assign({}, { 'id': item.id }));
      if (res.status == '0') {
        if (type == 1) {
          this.FileList1.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        } else if (type == 2) {
          this.FileList2.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        } else if (type == 3) {
          this.FileList3.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        } else if (type == 4) {
          this.FileList4.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        } else if (type == 5) {
          this.FileList5.forEach((value) => {
            //uid要改成guid,isshow变成false
            if (value.uid == file.uid) {
              value.isShow = false
              value.uid = file.response.data.substring(
                file.response.data.lastIndexOf('=') + 1
              )
            }
          })
        }
        this.FileList = this.FileList1.concat(
          this.FileList2.concat(this.FileList3.concat(this.FileList4))
        )
      } else if (
        res.status == '401' ||
        res.status == '402' ||
        res.status == '403'
      ) {
        this.$message.error(res.message)
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('hasRoles')
        this.$router.push('/login')
      }
    },
    selectChange(type) {
      if (type == 1 && this.form.leadLawyer.length == 1) {
        this.GetApprove()
        this.GetDepartmentLeaders(this.form.leadLawyer[0], 'case')
      }
      this.selectedLawyer = this.form.leadLawyer.concat(this.form.coCounsel)
    },
    computeDifferenceSet(currentSelectValue) {
      //计算每个下拉菜单的可以选中的选项
      let remainingOption = this.Lawyer.filter((item) => {
        return (
          this.selectedLawyer.indexOf(item.id) == -1 ||
          currentSelectValue.indexOf(item.id) != -1
        )
      })
      return remainingOption
    },
    //立项日历
    onMouseOver() {
      if (
        this.form.approvaldate != undefined &&
        this.form.approvaldate != null
      ) {
        this.$refs.iconDate.style.display = 'none'
      }
    },

    onMouseleave() {
      this.$refs.iconDate.style.display = 'block'
    },

    handleCancle() {},
    Post(form) {
      this.form.BiddingSchemes = this.FileList1.map((v) => {
        return v.uid
      })
      this.form.acceptanceRuling = this.FileList2.map((v) => {
        return v.uid
      })
      this.form.administratorDecision = this.FileList3.map((v) => {
        return v.uid
      })
      this.form.annex = this.FileList4.map((v) => {
        return v.uid
      })
      this.form.FreeFile = this.FileList5.map((v) => {
        return v.uid
      })
      this.form.dialogform.file = this.FileList.map((v) => {
        return v.uid
      })
      var labelArr = []
      var allLawyer = this.form.leadLawyer.concat(this.form.coCounsel)
      allLawyer.forEach((item) => {
        this.Lawyer.forEach((value) => {
          if (item == value.id && value.practice) {
            labelArr.push(item.practice)
          }
        })
      })

      if (labelArr.length == allLawyer.length) {
        this.$message.error('实习律师不能单独录案件')
        return
      }
      this.$refs[form].validate((success) => {
        if (success) {
          // this.dialogform.SealType = this.form.sealType
          // this.dialogform.applicant = this.form.leadLawyer[0]
          // this.SealChange()
          // this.FileList = this.FileList1.concat(
          //   this.FileList2.concat(this.FileList3.concat(this.FileList4))
          // )
          //冲突
          this.CaseConflictSelect()
          
          // console.log(this.dialogform.file)
        } else {
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          this.$message.error('有必填项为空')
        }
      })
    },
    //案件冲突
    CaseConflictSelect(){
      this.isLoading = true
      caseConflictApi({
                  listLitigant_param: [{IsUnit: false, Name: this.form.extInfo.debtorName, IsClient: true, Attribute: "债务人",Idnumber:this.form.extInfo.idnumber}],
                  CaseId: null,
                  Attribute: "债务人"
                }).then((res) => {
                  if (res.data.status == 'success') {
                    // 弹出案件冲突
                    this.dialogallConflictCase = res.data.data
                    if(this.dialogallConflictCase.length>0){
                      this.isLoading = false

                      this.allConflictCount=0
                      this.formConflict.conflictApproval=null
                      this.conflictShow=false
                      if(this.dialogallConflictCase.length > 0){
                        this.conflictList=this.dialogallConflictCase.filter(item => item.conId == 1)
                        this.allConflictCount  = this.allConflictCount +this.conflictList.length
                        if(this.conflictList.length==0){
                          this.conflictList.push(this.dialogallConflictCase[0])
                        }
                        if(this.dialogallConflictCase.length>this.conflictList.length&&this.dialogallConflictCase.length>1){
                          this.dialoghasMore=true
                        }
                      }
                      // console.log(this.allConflictCount )
                      if(this.allConflictCount>0){
                         this.GetConflictMember()
                      }else{
                        this.caseConflict = true
                    
                      }

                    }else{
                      this.addEnter('ruleformseal')
                    }
                  } else if (
                    res.data.status == '401' ||
                    res.data.status == '402' ||
                    res.data.status == '403'
                  ) {
                    this.$message.error(res.data.message)
                    window.sessionStorage.removeItem('token')
                    window.sessionStorage.removeItem('hasRoles')
                    this.$router.push('/login')
                    return
                  } else {
                    this.isLoading = false
                    this.$message.error(res.data.message)
                  }
                  
                })
      },
       // 继续录入
    conflict(formref) {
      this.$refs[formref].validate((valid) => {
        if (valid) {
          // 确认新增
          this.ProcessType = ['case_entry', 'type_seal']
          this.caseConflict = false // 冲突
          this.addEnter('ruleformseal')
        }else{
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
        }
      }
      )
    

      // this.caseConflict = false // 冲突
      // this.addEnter('ruleformseal')
     
    },
    getRandomColor(item, show) {
      if (show) return '#e86e30'
      else if (item) return 'blue'
    },
    // 我再想想
    edit() {
      this.conflictList = []
      this.caseConflict = false // 冲 突
      this.dialogshowAllCase=false
      this.dialoghasMore=false
      this.formConflict.conflictApproval=null
    },
    conflictClick(row){
      this.chongCaseType = row.typeId.substring(21, 23)
      allCaseApi({
        Id: row.id,
        SelectType: 1 //（0：案件管理，1：案件明细）
      }).then((res) => {
        if (res.data.status == '0') {
          // 案件信息
          this.CTform = res.data.data[0]

          //其他东西
          this.CTform.bcz = JSON.parse(res.data.data[0].bcz)
          for (var i = 0; i < this.CTform.biddingSchemes.length; i++) {
            var name = this.CTform.biddingSchemes[i].name.split('.')[0]
            var type = this.CTform.biddingSchemes[i].name.substring(
              this.CTform.biddingSchemes[i].name.lastIndexOf('.') + 1
            )
          }
          this.isChong = true
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    addEnter(form) {
      //录入

      // console.log(this.form.extInfo)
      this.$refs['ruleformseal'].validate((success) => {
        if (success) {
          this.isLoading = true
          
          // if (this.form.extInfo.opentime) {
          //   this.form.extInfo.opentime = this.JsonTime(
          //     this.form.extInfo.opentime
          //   ) //时间格式转换
          // }
          // this.form.bcbdTable.forEach((element) => {
          //   if (element.paymentDate) {
          //     element.paymentDate = this.JsonTime(element.paymentDate)
          //   }
          // })
          // if (this.form.chargingMethod == '免费') {
          //   this.form.fixed = null //定额收费金额
          //   this.form.riskFixed = 0 //半风险中的定额收费金额
          //   this.form.riskRatio = 0 //风险收费比例
          //   this.form.bcbdTable = []
          // } else if (this.form.chargingMethod == '固定收费') {
          //   this.form.riskFixed = 0 //半风险中的定额收费金额
          //   this.form.riskRatio = 0 //风险收费比例
          // } else {
          //   this.form.fixed = null //定额收费金额

          //   if (this.form.riskFixed == 0) {
          //     this.form.bcbdTable = []
          //   }
          // }
          // 筛选选中的打印材料
          var newCities = []
          var st = []
          this.form.dialogform.checkedCities.forEach((cv) => {
            this.form.dialogform.cities.forEach((cvc) => {
              if (cv == cvc.name) {
                newCities.push(cvc)
                if (cvc.stype != null && cvc.stype != '') {
                  st.push(cvc.stype)
                }
              }
            })
          })
          var nst = st
            .flat()
            .filter(Boolean)
            .filter(
              (value, index, self) => self.indexOf(value) === index && value
            )
            .join(',')
          BankruptAdd({
            LinkId: this.$route.query.guid,
            CaseType: '破产案件',
            Title: this.form.title,
            Cause: this.form.cause,
            CaseStatus: this.form.casestatus,
            Approve: this.form.approve, //项目二次审批人

            postTime: this.form.postTime, //立项时间
            Source: this.form.source,
            AcceptUnit: this.form.acceptUnit,
            AcceptCode: this.form.acceptCode,
            LeadLawyer: this.form.leadLawyer,
            CoCounsel: this.form.coCounsel,
            ExtInfo: JSON.stringify(this.form.extInfo), //扩展字段
            Bidfile: this.form.BiddingSchemes,
            FreeFile: this.form.FreeFile,
            OtherFile: this.form.annex,
            AcceptanceRuling: this.form.acceptanceRuling,
            AdministratorDecision: this.form.administratorDecision,
            ChargingMethod: this.form.chargingMethod,
            SubjectMatter: this.form.subjectMatter,
            AmountOfSubject: this.form.amountOfSubject==""?null: this.form.amountOfSubject,
            Introduction: this.form.introduction,
            Remark: this.form.remark,
            Fixed: this.form.fixed == null||this.form.fixed=='' ? null : this.form.fixed,
            RiskFixed: this.form.riskFixed == null||this.form.riskFixed=='' ? 0: this.form.riskFixed,
            RiskRatio: this.form.riskRatio == null || this.form.riskRatio == ''? 0 : this.form.riskRatio,
            // BillingDetail: this.form.bcbdTable, //收费明细
            BillingDetail: null, //收费明细
            // SealType: this.form.sealType, //用章
            SealType: nst,
            newSealTypes: JSON.stringify(newCities),
            ApplicantId: this.form.dialogform.applicant,
            // Approver: this.form.dialogform.approver,
            Seallist: this.form.dialogform.file,
            Reason: this.form.dialogform.reason,
            DepartmentLeaders: this.form.departmentLeaders,
            zwr :this.form.extInfo.debtorName,
            idnumber:this.form.extInfo.idnumber,
            ConflictApproval:this.formConflict.conflictApproval==''?null:this.formConflict.conflictApproval
            // SealLeaders: this.form.dialogform.SealLeaders
          }).then((res) => {
            if (res.data.status == 'success') {
              var type = 'draftFormBankinput'
              if (this.BidId) {
                type = 'draftForm' + this.BidId
              }
              var cgForm = JSON.parse(localStorage.getItem(type))
              // console.log('cgForm', cgForm)
              // console.log('cgid', this.cgid)
              if (cgForm != null) {
                if (cgForm.length == 1) {
                  localStorage.removeItem(type)
                } else {
                  cgForm.forEach((value, index, arr) => {
                    if (value.uuid == this.cgid) {
                      return arr.splice(index, 1)
                    }
                  })
                  localStorage.setItem(type, JSON.stringify(cgForm))
                }
              }
              this.history()
              // this.$router.push({
              //   path: `/home/bankrupt/bankruptCase`
              // })
              this.$message.success('录入成功！')
            } else if(res.data.status=='Filefail'){
            this.$message.error(res.data.message)
            this.isLoading = false
           
            this.dianji = false
            this.FileList1 = []
            this.FileList = []
            this.FileList2 = []
            this.FileList3 = []
            this.FileList4 = []
            this.FileList5 = []
          }else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
            }
            this.isLoading = false
            this.dianji = false
          })
        } else {
          this.$nextTick(() => {
            const errorField = this.$el.querySelector('.el-form-item.is-error')
            if (errorField) {
              errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          this.$message.error('有必填项为空')
        }
      })
    },
    // //时间转换
    // // 时间格式
    // handleTime(time, format) {
    //   if (time == null || time == undefined || time == "") {
    //     return "";
    //   }
    //   var t = new Date(time.toString().replace(/-/g, "/"));
    //   var tf = function (i) {
    //     return (i < 10 ? '0' : '') + i
    //   };
    //   return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
    //     switch (a) {
    //       case 'yyyy':
    //         return tf(t.getFullYear());
    //         break;
    //       case 'MM':
    //         return tf(t.getMonth() + 1);
    //         break;
    //       case 'mm':
    //         return tf(t.getMinutes());
    //         break;
    //       case 'dd':
    //         return tf(t.getDate());
    //         break;
    //       case 'HH':
    //         return tf(t.getHours());
    //         break;
    //       case 'ss':
    //         return tf(t.getSeconds());
    //         break;
    //     }
    //   })
    // },
    Getdetail() {
      //获取招标字段
      BidDetail({ Id: this.BidId }).then((res) => {
        if (res.data.status == 'success') {
          var data = res.data.data
          this.form.title = data.title
          this.form.cause = data.cause
          // this.form.approve = data.approve;

          this.form.name = data.name
          this.form.source = data.source
          this.form.leadLawyer = data.uid.split()
          this.form.dialogform.applicant = data.uid
          // this.form.coCounsel = data.coCounsel
          this.form.chargingMethod = data.chargingMethod
          this.form.acceptUnit = data.acceptUnit
          this.form.amountOfSubject = data.amountOfSubject
          this.form.remark = data.remark
          this.form.introduction = data.introduction
          this.form.fixed = data.fixed == 0 ? null : data.fixed
          this.form.riskFixed = data.riskFixed == 0 ? null : data.riskFixed
          this.form.riskRatio = data.riskRatio == 0 ? null : data.riskRatio
          this.form.sealType = data.sealType == null ? '' : data.sealType
          if (data.bcbdTable.length > 0) {
            this.form.bcbdTable = data.bcbdTable
          }
          // this.caoGao1 = true
          var extInfo = JSON.parse(data.extInfo)
          this.form.extInfo.partner = extInfo.partner
          this.form.extInfo.draft = extInfo.draft
          this.selectChange('1')
          this.SealChange()
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    Price(rule, value, callback) {
      var price = /^\d+(\.\d{0,2})?$/
      if (!value) {
        callback(new Error('不能为空'))
      } else if (value <= 0) {
        callback(new Error('请输入大于0的金额'))
      } else if (!price.test(value)) {
        callback(new Error('请输入正确格式的金额')) //防止输入多个小数点
      } else {
        callback()
      }
    },
    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    JsonTime(date) {
      // yyyy-MM-ddT HH:MM:SS
      var t = new Date(date).getTime()
      var d = new Date(t + 8 * 3600 * 1000).toISOString()
      return d
    },
    // 必选标识
    addRedStar(h, { column }) {
      return [
        h('span', { style: 'color: #F56C6C' }, '*'),
        h('span', ' ' + column.label)
      ]
    },

    // this.BidId
    // 全新录入监控
    inputDraft(newVal) {
      var type = 'draftFormBankinput'
      if (this.BidId) {
        type = 'draftForm' + this.BidId
      }
      var cgForm = JSON.parse(localStorage.getItem(type))
      // console.log('全新录入监控', cgForm)
      // if (cgForm.length > 1) {
      cgForm = cgForm.slice(0, -1)
      cgForm.push(newVal)

      localStorage.setItem(type, JSON.stringify(cgForm))
      // } else {
      //   localStorage.setItem('draftForm' + this.BidId, JSON.stringify(newVal))
      // }
    },

    // 保存草稿
    saveCaoGao() {
      var type = 'draftFormBankinput'
      this.form.draftFormType = 'Bankinput'
      if (this.BidId) {
        type = 'draftForm' + this.BidId
        this.form.draftFormType = this.BidId
      }
      var cgForm = JSON.parse(localStorage.getItem(type)) //读取

      var you = false
      if (cgForm != null) {
        cgForm.forEach((value, index, arr) => {
          if (value.uuid == this.cgid) {
            you = true
            return (arr[index] = this.form)
          }
        })
      }

      if (you) {
        // 再次写入local
        localStorage.setItem(type, JSON.stringify(cgForm))
      } else {
        this.form.draftFormId = window.sessionStorage.getItem('userId')
        this.form.uuid = this.guid()
        if (cgForm == null || cgForm == []) {
          this.caoGao.push(this.form)
          localStorage.setItem(type, JSON.stringify(this.caoGao))
        } else {
          cgForm.push(this.form)
          localStorage.setItem(type, JSON.stringify(cgForm))
        }
      }
      this.$message.success('保存成功！')
    },

    // // 修改草稿
    // updateCaoGao() {
    //   // 取出local数据并修改
    //   var cgForm = JSON.parse(localStorage.getItem('draftForm' + this.numType))
    //   cgForm.forEach((value, index, arr) => {
    //     if (value.uuid == this.cgid) {
    //       return (arr[index] = this.form)
    //     }
    //   })

    //   // 再次写入local
    //   localStorage.setItem('draftForm' + this.numType, JSON.stringify(cgForm))

    //   this.$message.success('修改成功！')
    // },

    // 全新录入
    async inputDraftNew() {
      // option改变事件
      var type = 'draftFormBankinput'
      this.form.draftFormType = 'Bankinput'
      if (this.BidId) {
        type = 'draftForm' + this.BidId
        this.form.draftFormType = this.BidId
        this.Getdetail()
      } else {
        this.user('bank')
      }

      this.centerDialogVisible = false
    },

    // 取出选择的草稿
    cgInput(cgid) {
      if (cgid == null || cgid == '') {
        return this.$message.error('请选择草稿')
      }
      var type = 'draftFormBankinput'
      if (this.BidId) {
        type = 'draftForm' + this.BidId
      }
      var cgForm = JSON.parse(localStorage.getItem(type))
      cgForm.forEach((v, i, arr) => {
        if (v.uuid == cgid) {
          this.form = v
          // this.dialogform.applicant = this.form.leadLawyer[0];
          return
        }
      })

      this.form.dialogform.file = []
      // 事件改变
      this.selectChange('1')
      // this.SF_Chargestatus(this.form.chargingMethod)
      // this.LeadLawyerChange(this.form.leadLawyer)
      // this.bmzgChange()
      this.SealChange()

      this.caoGao1 = true
      this.cgDialogVisible = false
      this.centerDialogVisible = false
    },
    // 删除草稿
    deleteCaoGao() {
      // localStorage.removeItem('draftForm' + this.numType)
      // this.$message.success('删除草稿成功！')
      // this.centerDialogVisible = false
      // this.caoGao = []
      // setTimeout(() => {
      //   this.inputDraftNew()
      // }, 1000)
      this.scDialogVisible = true
    },
    // 删除草稿
    scCG(scid) {
      // console.log(scid)
      // console.log(this.caoGao)
      if (scid == null) {
        return this.$message.error('请选择要删除的草稿！')
      }
      for (var a = 0; a < scid.length; a++) {
        this.caoGao.forEach((value, index, array) => {
          if (value.uuid == scid[a]) {
            array.splice(index, 1)
          }
        })
      }
      var type = 'draftFormBankinput'
      if (this.BidId) {
        type = 'draftForm' + this.BidId
      }
      if (this.caoGao.length == 0) {
        localStorage.removeItem(type)
      } else {
        // localStorage.setItem(type, JSON.stringify(this.caoGao))
      }
      this.$message.success('删除成功')
      this.scDialogVisible = false
      this.centerDialogVisible = false
      this.inputDraftNew()
    },
    // 原有草稿录入监控
    inputDraftOld(nv) {
      // 取出local数据并修改
      var type = 'draftFormBankinput'

      if (this.BidId) {
        type = 'draftForm' + this.BidId
      }
      var cgForm = JSON.parse(localStorage.getItem(type))
      cgForm.forEach((value, index, arr) => {
        if (value.uuid == this.cgid) {
          return (arr[index] = nv)
        }
      })

      // 再次写入local
      // console.log('再次写入local', cgForm)
      localStorage.setItem(type, JSON.stringify(cgForm))
    },

    // 判断当前案件是否存在草稿 根据投标录入
    caoGaoSelect() {
      var type = 'draftFormBankinput'
      if (this.BidId) {
        type = 'draftForm' + this.BidId
      }
      var cgForm = JSON.parse(localStorage.getItem(type))
      // console.log(cgForm)
      // console.log(cgForm.length)
      if (cgForm != null) {
        if (cgForm.length > 0) {
          cgForm.forEach((value, index, arr) => {
            if (value.draftFormId == window.sessionStorage.getItem('userId')) {
              this.caoGao.push(value)
              this.my = true
            }
          })
          if (this.my) {
            this.centerDialogVisible = true
          } else {
            this.inputDraftNew()
          }
        }
      } else {
        this.inputDraftNew()
      }
    },

    caoGaoSelectBank() {
      //直接破产案件录入
      var cgForm = JSON.parse(localStorage.getItem('draftFormBankinput'))

      // console.log(cgForm.length)
      if (cgForm != null) {
        if (cgForm.length > 0) {
          cgForm.forEach((value, index, arr) => {
            if (value.draftFormId == window.sessionStorage.getItem('userId')) {
              this.caoGao.push(value)
              this.my = true
            }
          })
          if (this.my) {
            this.centerDialogVisible = true
          } else {
            this.inputDraftNew()
          }
        }
      } else {
        this.inputDraftNew()
      }
    },

    // 草稿录入
    caoGaoInput() {
      // this.form = JSON.parse(localStorage.getItem('draftForm' + this.BidId))
      // this.SF_Chargestatus(this.form.chargingMethod)
      // this.LeadLawyerChange(this.form.leadLawyer)
      // this.bmzgChange()
      // this.centerDialogVisible = false
      this.cgDialogVisible = true
    },

    S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    },
    // guid生成
    guid() {
      return (
        this.S4() +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        this.S4() +
        this.S4()
      )
    },

    async inputType() {
      this.form.dialogform.cities = [
        {
          name: '案件审批单', // 模板名
          stype: ['official_seal'], // 用章类型
          type: 2
        }
      ]
      if (this.form.dialogform.checkedCities.length > 0) {
        this.form.dialogform.checkedCities = []
      }
      this.form.dialogform.cities.forEach((value) => {
        this.form.dialogform.checkedCities.push(value.name)
      })
    },

    // 用章类型改变,查找审批人
    async GetSealLevel() {
      if (
        this.form.dialogform.applicant == '' ||
        this.form.dialogform.applicant == null
      ) {
        return
      }
      var newSeal = []
      // console.log(this.form.dialogform.cities)
      this.form.dialogform.cities.forEach((value) => {
        if (value.stype.length > 0) {
          newSeal.push(value.stype.join(','))
        }
      })
      var uniqueArr = [...new Map(newSeal.map((item) => [item, item])).values()]
      var news = Array.from(
        new Set(uniqueArr.flatMap((item) => item.split(',')))
      )
      if (JSON.stringify(news) !== JSON.stringify(this.selectedSealType)) {
        this.GetSealApprove()
        this.selectedSealType = news
      }
    },
    closChong() {
      this.isChong = false
    },
    tableRowClass({ row, rowIndex }){
      console.log("isoth",row.isOther)
      if (row.isOther) {
        return 'beig-row';
      }else{
        return '';
      }
      
    }
  },
  async created() {
    // console.log('BidId', this.$route.query.guid)
    this.BidId = this.$route.query.guid
    await this.inputType()
    this.GetLit()
    if (this.BidId) {
      this.caoGaoSelect()
      this.user()

      // this.$watch(
      //   'form',
      //   (newVal, oldVal) => {
      //     console.log('保存草稿', newVal)
      //     this.inputDraft(newVal)
      //   },
      //   { deep: true }
      // )
    } else {
      this.caoGaoSelectBank()
      this.user()
    }
    await this.GetSealLevel()
  },
  watch: {
    caoGao1: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.$watch(
            'form',
            (newVal, oldVal) => {
              // console.log('保存草稿old', newVal)
              // this.inputDraftOld(newVal)
            },
            { deep: true }
          )
        }
      },
      deep: true
    },

    newcaoGao1: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.$watch(
            'form',
            (newVal, oldVal) => {
              // console.log('保存草稿new', newVal)
              this.inputDraft(newVal)
            },
            { deep: true }
          )
        }
      },
      deep: true
    }
  }
}
</script>
  
<style lang="less" scoped>

/deep/.beig-row{
      background: #e6e5e4 !important;
  }
#bankinput {
  width: 100%;
}

#bankinput .title {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
}

#bankinput .main {
  width: 100%;
  margin: auto;
  padding-bottom: 30px;
}

#bankinput .main_card {
  width: 100%;
  border-radius: 12px;
  padding-bottom: 20px;
}

#bankinput .case {
  width: 100%;
  margin: auto;
  margin-top: 40px;
}

#bankinput .top {
  width: 100%;
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 19px;
  font-weight: 400;
  padding-left: 58px;
  margin-bottom: 32px;
}

#bankinput .icon {
  width: 4px;
  height: 18px;
  background: #3077e6;
  border-radius: 9px;
  margin-right: 5px;
}

#bankinput .contain {
  width: 100%;
}

#bankinput .divider {
  width: calc(100% - 50px);
  float: right;
  border-top: 1px solid rgba(238, 239, 242, 1);
  margin-bottom: 32px;
  margin-top: 10px;
}

#bankinput /deep/ .el-form-item__label {
  font-size: 17px;
  font-weight: 400;
}

#bankinput .money /deep/ .el-form-item__content {
  display: flex;
  align-items: center;
}

#bankinput .select {
  width: 100%;
}

// 日历
#bankinput ::v-deep .el-input__prefix {
  display: none;
}

#bankinput ::v-deep .el-input--prefix .el-input__inner {
  padding-left: 15px;
}

#bankinput .date_box {
  .el-icon-date {
    position: absolute;
    top: 50%;
    right: 10px;
    z-index: 0;
    color: #c0c4cc;
    font-size: 14px;
    transform: translateY(-50%);
  }

  /deep/ .el-range__close-icon {
    position: absolute;
    right: 34px;
    top: 54%;
    transform: translateY(-50%);
  }
}

#bankinput .fjchoose {
  border: 1px solid rgba(48, 119, 230, 1);
  font-size: 16px;
  font-weight: 400;
  color: rgba(48, 119, 230, 1);
}

#bankinput .el-upload__tip {
  font-size: 14px;
  font-weight: 400;
  color: rgba(182, 182, 182, 1);
  margin-left: 10px;
}

//按钮
#bankinput .allbtn {
  width: 100%;
  text-align: center;
  // margin-top: 80px;
  position: fixed;
  top: 98%; /* 距顶部居中显示 */
  left: 50%; /* 距左侧居中显示 */
  transform: translate(-50%, -50%); /* 水平、垂直居中 */
  z-index: 999;
  background-color: #f5f5f5;
}

#bankinput .history {
  border: 1px solid rgba(43, 200, 135, 1);
  color: rgba(43, 200, 135, 1);
}

//收费明细
.addrow {
  float: right;
  margin-bottom: 10px;
  z-index: 1;

  .el-icon-plus {
    color: #fe964a;
    cursor: pointer;
  }
}

//表格
.detail::v-deep .el-table th.el-table__cell {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: #fafafa;
}

.party{
  margin-bottom: 55px;
  margin-left: 5%;
  ::v-deep .isclient-row {
    background: #fff1dc;
  }

  ::v-deep .el-table__body tr:hover > td {
    background-color: transparent !important;
  }
  ::v-deep .el-input__inner {
    border: none;
    height: 24px;
    line-height: 24px;
    text-align: center;
  }
}

// ::v-deep tbody tr:hover > td {
//   background-color: transparent !important;
// }
/deep/ .el-table th {
  //标题背景色
  background-color: #fafafa;
}

.copy {
  color: #3077e6;
  cursor: pointer;
}

.bgdel {
  color: #fe964a;
  margin-left: 8px;
  cursor: pointer;
}

.party /deep/.el-input__icon {
  height: 100%;
  width: 25px;
  text-align: center;
  transition: all 0.3s;
  line-height: 24px;
}

//附件回显
.upload_file {
  width: 365px;
}

#bankinput .file_show {
  width: 360px;
}

#bankinput .fj {
  // display: inline-flex;
  display: flex;
  align-items: center;
  background: #f5f7fa;
  justify-content: flex-start;
  padding: 10px;
  padding-right: 20px;
  margin-bottom: 10px;
}

#bankinput img {
  width: 100%;
  height: 100%;
}

#bankinput .name {
  display: inline-flex;
  flex-direction: column;
  padding-left: 10px;
}

#bankinput .fname {
  width: 280px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

// 弹出框
/deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

#bankinput .word {
  line-height: 24px;
  cursor: default;
}

#bankinput /deep/.el-form-item__content {
  line-height: 20px;
  position: relative;
  font-size: 14px;
}

#bankinput .look {
  color: #fe964a;
  margin-right: 10px;
}

#bankinput .down {
  color: #2bc887;
  margin-right: 10px;
}

#bankinput .del {
  color: hsl(356, 93%, 50%);
}

//进度条
#bankinput .uploadprocess {
  width: 360px;
}

#bankinput .uploadname {
  width: 320px;
  text-overflow: ellipsis;
  /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap;
  /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden;
  /*超出部分隐藏*/
}

#bankinput .jdtext {
  width: 360px;
  display: flex;
}

#bankinput .per {
  width: 40px;
  text-align: right;
}

/deep/ .el-progress-bar__outer {
  //进度条的高度
  height: 4px !important;
}

.yz_input {
  ::v-deep .el-input__inner {
    width: 300px !important;
  }
}
::v-deep .el-form-item {
  margin-bottom: 16px !important;
}
</style>
  